import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { TextField, createMuiTheme, ThemeProvider, Input } from "@material-ui/core";
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector } from 'react-redux';

const theme = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                '&&[class*="MuiFilledInput-root"] $input': {
                    padding: "0 !important",
                },
                height: "55px !important",
                background: "#E8F8F8",
                '&$disabled': {
                    backgroundColor: '#454545 !important',
                },
            }
        },
        MuiFilledInput: {
            root: {
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#000028",
                    backgroundColor: "#E8F8F8",
                },
                "&&&&:hover": {
                    backgroundColor: "#E8F8F8"
                },
                "&$disabled": {
                    "pointerEvent": "none",
                    "color": "#707080",
                    "backgroundColor": "#001035",
                    "border": "2px solid #707070",
                    "borderRadius": "0",
                    "&:before": {
                        "borderBottom": "1px solid #001035",
                    },
                    "&:hover:before": {
                        "borderBottom": "1px solid #001035",
                        "borderBottomStyle": "solid"
                    }
                }
            },
            underline: {
                "&:before": {
                    borderBottom: "2px solid #E8F8F8",
                    transition: "border-bottom-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                },
                "&:after": {
                    borderBottom: "2px solid #E8F8F8",
                    transition: "border-bottom-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                },
                "&:hover:before": {
                    borderBottom: "2px solid #00CCCC"
                },
                "&:hover:after": {
                    borderBottom: "2px solid #6CD6D6"
                },
                "&:focused:after": {
                    borderBottom: "2px solid #6CD6D6"
                },
                "&:disabled:before": {
                    border: "none"
                }
            },
        },

        MuiButtonBase: {
            root: {
                background: "#E8F8F8",
                '&$disabled': {
                    backgroundColor: '#454545 !important',
                },
            },
        },
        MuiDialogActions: {
            root: {
                background: "#00CCCC"
            }
        },
        MuiDialogTitle: {
            root: {
                padding: "8px 24px",
            },
        },
        //MuiTextField: {
        //    root: {
        //        color: "#002949",
        //        background: "#000028",
        //        width: '100%'
        //    },
        //},
        MuiFormLabel: {
            root: {
                //color: "#B3B3BE",
                color: "#000028",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#00CCCC",
                },
            }
        },
        MuiTextField: {
            root: {
                color: "#000028",
                background: "#00CCCC",
                width: '100%'
            },
        },
        MuiInputLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                //color: "#B3B3BE",
                color: "#4C4C68",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#00CCCC"
                }
            },
            asterisk: {
                color: "red"
            }
        },
        MuiInputBase: {
            root: {
                color: "#4C4C68"
            },
            input: {
                backgroundColor: "#EBFBFB",
                color: "#4C4C68",
                borderBottom: "0px solid #707070",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#E0F9F9",
                    backgroundColor: "#CCF5F5",
                },
                "&$hover": {

                    backgroundColor: "#CCF5F5",
                }
            }
        },
        MuiInput: {
            root: {
                height: "56px",
                backgroundColor: "#E8F8F8",
                color: "#000028",
                paddingLeft: "0px",
                "&$focused": {
                    backgroundColor: "#E8F8F8",
                }
            },
            underline: {
                "&:before": {
                    borderBottom: "0px solid #FFFFFF",
                    transition: "border-bottom-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                },
                "&:after": {
                    borderBottom: "2px solid #FFFFFF",
                    transition: "border-bottom-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                },
                "&:hover:before": {
                    borderBottom: "2px solid #FFFFFF"
                },
                "&:hover:after": {
                    borderBottom: "2px solid #FFFFFF"
                },
                "&:focused:after": {
                    borderBottom: "2px solid  #FFFFFF"
                },
                "&:disabled:before": {
                    border: "none"
                }
            },
        },
        MuiSelect: {
            root: {
                backgroundColor: "#E8F8F8",
                color: "#000028"
            }
        },
        MuiFormControl: {
            root: {
                color: "#FFFFFF",
                width: "100",
                paddingLeft: "0px"
            }
        },
        MuiList: {
            root: {
                backgroundColor: "#CCF5F5"
            }
        },
        MuiListItem: {
            root: {
                color: "#FFFFFF",
            }
        },
        MuiPaper: {
            rounded: {
                borderRadius: "20px",
                marginBottom: "20px",
                background: "#CCF5F5"
            }
        },

        MuiToolbar: {
            root: {
                background: "#000028",
                color: "#FFFFFF"
            }
        },
        MuiTablePagination: {
            root: {
                borderBottom: "none"
            },
            toolbar: {
                borderTop: `1px solid #FFFFFF`,
                "& MuiTypography-root": {
                    color: `#00CCCC !important`
                }
            },
            menuItem: {
                color: "#FFFFFF"
            },
            selectIcon: {
                color: "#00CCCC"
            },
            input: {
                backgroundColor: "#000028"
            }
        },
        MuiTypography: {
            caption: {
                color: "#000028"
            }
        },
        MuiTableSortLabel: {
            root: {
                color: "#00CCCC",
                "&$focused": {
                    color: "#00CCCC",
                },
                "&$hover": {
                    color: "#FFFFFF"
                },
                "&$active": {
                    color: "#00CCCC"
                },
                "& div:hover": {
                    color: "#00CCCC"
                }
            },
            icon: {
                color: `#00CCCC !important`,
                "&$hover": {
                    color: "#FFFFFF"
                },
                "&$active": {
                    color: "#00CCCC"
                },
            },
            iconDirectionDesc: {
                color: `#00CCCC !important`,
                "&$hover": {
                    color: "#FFFFFF"
                },
                "&$active": {
                    color: "#00CCCC"
                },
            },
            iconDirectionAsc: {
                color: `#00CCCC !important`,
                "&$hover": {
                    color: "#FFFFFF"
                },
                "&$active": {
                    color: "#00CCCC"
                },
            }
        },
        MuiTableCell: {
            root: {
                color: "#FFFFFF !important"
            },
            body: {
                background: "#000028",
                color: "#FFFFFF"
            }
        },
        //MuiFormControl: {
        //    root: {
        //        paddingLeft: "0px"
        //    }
        //},
        MuiSvgIcon: {
            root: {
                color: "#6a7272"
            }
        },
        MuiPickersBasePicker: {
            pickerView: {
                background: "#000028"
            },
            background: "#000028",
            container: {
                background: "#000028"
            }
        },
        MuiPickersDatePickerRoot: {
            toolbar: {
                background: "#000028"
            }
        },
        MuiPickersCalendarHeader: {
            iconButton: {
                backgroundColor: "none",
                color: "#FFFFFF"
            },
            switchHeader: {
                color: "#FFFFFF"
            },
            daysHeader: {
                color: "#FFFFFF"
            },
            dayLabel: {
                color: "#FFFFFF"
            }
        },
        MuiPickersYear: {
            root: {
                color: "#FFFFFF"
            }
        },
        //MuiPickersBasePicker: {
        //    container: {
        //        background: "#000028"
        //    }
        //},
        MuiPickersDay: {
            day: {
                color: "#FFFFFF"
            }
        },
        MuiButton: {
            textPrimary: {
                color: "#FFFFFF"
            }
        },
        MuiTable: {
            root: {
                backgroundColor: "#000028"
            }
        },
        MuiFormHelperText: {
            contained: {
                marginTop: "8px",
                backgroundColor: "white",
                marginBottom: "-10px !important",
                marginLeft: "0px !important",
                marginRight: "0px !important",
                color: "red !important",
                lineHeight: "0.5 !important"
            },
            filled: {
                backgroundColor: "#FFFFFF !important"
            }
        },
    }
});

export default function HiringForm(props) {
    const useStyles = makeStyles((theme) => ({
        formControl: {
            minWidth: "100%",
            color: "#00CCCCC",
            background: "#FFFFFF"
        },
    }));

    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const siemensToken = useSelector((state) => state.saveTokenReducer.token);

    const classes = useStyles();
    const [studentId, setStudentId] = useState(0);
    const [formHeaderText1, setFormHeaderText1] = useState('Siemens Technical Academy India ');
    const [formHeaderText2, setFormHeaderText2] = useState('Student Admission Form');
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState(userDetails?.email);

    const [errorFirstName, setErrorFirstName] = useState(false);
    const [errorTextFirstName, setErrorTextFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState(false);
    const [errorTextLastName, setErrorTextLastName] = useState('');
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorTextEmail, setErrorTextEmail] = useState('');
    const [ContactNumber, setContactNumber] = useState('');
    const [errorContactNumber, setErrorContactNumber] = useState(false);
    const [errorTextContactNumber, setErrorTextContactNumber] = useState('');
    const [genter, setGenter] = useState(null);
    const [itemsGenter, setItemsGenter] = useState([]);

    const [fgfirstName, setfgFirstName] = useState('');
    const [errorfgFirstName, setErrorfgFirstName] = useState(false);
    const [errorTextfgFirstName, setErrorTextfgFirstName] = useState('');

    const [fgmiddleName, setfgMiddleName] = useState('');

    const [fglastName, setfgLastName] = useState('');
    const [errorfgLastName, setErrorfgLastName] = useState(false);
    const [errorTextfgLastName, setErrorTextfgLastName] = useState('');

    const [fgContactNumber, setfgContactNumber] = useState(1);

    const [mfirstName, setmFirstName] = useState('');
    const [errormFirstName, setErrormFirstName] = useState(false);
    const [errorTextmFirstName, setErrorTextmFirstName] = useState('');
    //const [inputFileValue, setInputFileValue] = useState(Date.now);
    const [mmiddleName, setmMiddleName] = useState('');

    const [mlastName, setmLastName] = useState('');
    const [errormLastName, setErrormLastName] = useState(false);
    const [errorTextmLastName, setErrorTextmLastName] = useState('');

    const [mContactNumber, setmContactNumber] = useState('');
    const [errormContactNumber, setErrormContactNumber] = useState(false);
    const [errorTextmContactNumber, setErrorTextmContactNumber] = useState('');

    const [presentAddress, setPresentAddress] = useState('');
    const [itemsQualification, setItemsQualification] = useState([]);
    const [itemsQualification9th, setItemsQualification9th] = useState([]);
    const [qualificationDet, setQualificationDet] = useState(1);
    const [qualificationDet9th, setQualificationDet9th] = useState(2);

    const [errorPresentAddress, setErrorPresentAddress] = useState(false);
    const [errorTextPresentAddress, setErrorTextPresentAddress] = useState('');

    const [yearofPassing, setYearofPassing] = useState('');
    const [yearofPassing9th, setYearofPassing9th] = useState('');
    const [erroryearofPassing, setErrorYearofPassing] = useState(false);
    const [errorTextyearofPassing, setErrorTextYearofPassing] = useState('');
    const [erroryearofPassing9th, setErrorYearofPassing9th] = useState(false);
    const [errorTextyearofPassing9th, setErrorTextYearofPassing9th] = useState('');

    const [percentage, setPercentage] = useState('');
    const [errorpercentage, setErrorPercentage] = useState(false);
    const [errorTextpercentage, setErrorTextPercentage] = useState('');

    const [percentage9th, setPercentage9th] = useState('');
    const [errorpercentage9th, setErrorPercentage9th] = useState(false);
    const [errorTextpercentage9th, setErrorTextPercentage9th] = useState('');

    const [nameofboard, setNameofBoard] = useState('');
    const [errorNameofboard, setErrorNameofboard] = useState(false);
    const [errorTextNameofboard, setErrorTextNameofboard] = useState('');

    const [nameofboard9th, setNameofBoard9th] = useState('');
    const [errorNameofboard9th, setErrorNameofboard9th] = useState(false);
    const [errorTextNameofboard9th, setErrorTextNameofboard9th] = useState('');

    const [englishObtained, setEnglishObtained] = useState('');
    const [errorEnglishObtained, setErrorEnglishObtained] = useState(false);
    const [errorTextEnglishObtained, setErrorTextEnglishObtained] = useState('');

    const [englishObtained9th, setEnglishObtained9th] = useState('');
    const [errorEnglishObtained9th, setErrorEnglishObtained9th] = useState(false);
    const [errorTextEnglishObtained9th, setErrorTextEnglishObtained9th] = useState('');

    const [englishOutof, setenglishOutof] = useState('');
    const [errorEnglishOutof, setErrorEnglishOutof] = useState(false);
    const [errorTextEnglishOutof, setErrorTextEnglishOutof] = useState('');

    const [englishOutof9th, setenglishOutof9th] = useState('');
    const [errorEnglishOutof9th, setErrorEnglishOutof9th] = useState(false);
    const [errorTextEnglishOutof9th, setErrorTextEnglishOutof9th] = useState('');

    const [englishperofMarks, setenglishperofMarks] = useState('');
    const [errorEnglishPerofMarks, seterrorEnglishPerofMarks] = useState(false);
    const [errorTextEnglishPerofMarks, seterrorTextEnglishPerofMarks] = useState('');

    const [englishperofMarks9th, setenglishperofMarks9th] = useState('');
    const [errorEnglishPerofMarks9th, seterrorEnglishPerofMarks9th] = useState(false);
    const [errorTextEnglishPerofMarks9th, seterrorTextEnglishPerofMarks9th] = useState('');

    const [mathmaticsObtained, setMathmaticsObtained] = useState('');
    const [errorMathmaticsObtained, seterrorMathmaticsObtained] = useState(false);
    const [errorTextMathmaticsObtained, seterrorTextMathmaticsObtained] = useState('');

    const [mathmaticsObtained9th, setMathmaticsObtained9th] = useState('');
    const [errorMathmaticsObtained9th, seterrorMathmaticsObtained9th] = useState(false);
    const [errorTextMathmaticsObtained9th, seterrorTextMathmaticsObtained9th] = useState('');

    const [mathmaticsOutof, setMathmaticsOutof] = useState('');
    const [errorMathmaticsOutof, setErrorMathmaticsOutof] = useState(false);
    const [errorTextMathmaticsOutof, setErrorTextMathmaticsOutof] = useState('');

    const [mathmaticsOutof9th, setMathmaticsOutof9th] = useState('');
    const [errorMathmaticsOutof9th, setErrorMathmaticsOutof9th] = useState(false);
    const [errorTextMathmaticsOutof9th, setErrorTextMathmaticsOutof9th] = useState('');

    const [mathmaticsperofMarks, setMathmaticsperofMarks] = useState('');
    const [errorMathmaticsPerofMarks, setErrorMathmaticsPerofMarks] = useState(false);
    const [errorTextMathmaticsPerofMarks, setErrorTextMathmaticsPerofMarks] = useState('');

    const [mathmaticsperofMarks9th, setMathmaticsperofMarks9th] = useState('');
    const [errorMathmaticsPerofMarks9th, setErrorMathmaticsPerofMarks9th] = useState(false);
    const [errorTextMathmaticsPerofMarks9th, setErrorTextMathmaticsPerofMarks9th] = useState('');

    const [scienceObtained, setScienceObtained] = useState('');
    const [errorScienceObtained, setErrorScienceObtained] = useState(false);
    const [errorTextScienceObtained, setErrorTextScienceObtained] = useState('');

    const [scienceObtained9th, setScienceObtained9th] = useState('');
    const [errorScienceObtained9th, setErrorScienceObtained9th] = useState(false);
    const [errorTextScienceObtained9th, setErrorTextScienceObtained9th] = useState('');

    const [scienceOutof, setScienceOutof] = useState('');
    const [errorScienceOutof, setErrorScienceOutof] = useState(false);
    const [errorTextScienceOutof, setErrorTextScienceOutof] = useState('');

    const [scienceOutof9th, setScienceOutof9th] = useState('');
    const [errorScienceOutof9th, setErrorScienceOutof9th] = useState(false);
    const [errorTextScienceOutof9th, setErrorTextScienceOutof9th] = useState('');

    const [scienceperofMarks, setScienceperofMarks] = useState('');
    const [errorSciencePerofMarks, setErrorSciencePerofMarks] = useState(false);
    const [errorTextSciencePerofMarks, setErrorTextSciencePerofMarks] = useState('');

    const [scienceperofMarks9th, setScienceperofMarks9th] = useState('');
    const [errorSciencePerofMarks9th, setErrorSciencePerofMarks9th] = useState(false);
    const [errorTextSciencePerofMarks9th, setErrorTextSciencePerofMarks9th] = useState('');

    const [totalObtained, setTotalObtained] = useState('');
    const [errorTotalObtained, setErrorTotalObtained] = useState(false);
    const [errorTextTotalObtained, setErrorTextTotalObtained] = useState('');

    const [totalObtained9th, setTotalObtained9th] = useState('');
    const [errorTotalObtained9th, setErrorTotalObtained9th] = useState(false);
    const [errorTextTotalObtained9th, setErrorTextTotalObtained9th] = useState('');

    const [totalOutof, setTotalOutof] = useState('');
    const [errorTotalOutof, setErrorTotalOutof] = useState(false);
    const [errorTextTotalOutof, setErrorTextTotalOutof] = useState('');

    const [totalOutof9th, setTotalOutof9th] = useState('');
    const [errorTotalOutof9th, setErrorTotalOutof9th] = useState(false);
    const [errorTextTotalOutof9th, setErrorTextTotalOutof9th] = useState('');

    const [errorQualification, setErrorQualification] = useState(false);
    const [errorTextQualification, setErrorTextQualification] = useState('');

    const [errorQualification9th, setErrorQualification9th] = useState(false);
    const [errorTextQualification9th, setErrorTextQualification9th] = useState('');

    const [errorGender, setErrorGender] = useState(false);
    const [errorTextGender, setErrorTextGender] = useState('');

    const [totalperofMarks, setTotalperofMarks] = useState('');
    const [errorTotalPerofMarks, setErrorTotalPerofMarks] = useState(false);
    const [errorTextTotalPerofMarks, setErrorTextTotalPerofMarks] = useState('');

    const [totalperofMarks9th, setTotalperofMarks9th] = useState('');
    const [errorTotalPerofMarks9th, setErrorTotalPerofMarks9th] = useState(false);
    const [errorTextTotalPerofMarks9th, setErrorTextTotalPerofMarks9th] = useState('');

    const [tradePrefered, setTradePrefered] = useState('');
    const [itemsTradePrefered, setItemsTradePrefered] = useState([]);

    const [birthYear, setBirthYear] = useState('');
    const [errorBirthYear, setErrorBirthYear] = useState(false);
    const [errorTextBirthYear, setErrorTextBirthYear] = useState('');

    const [open, setOpen] = useState(false);
    const [openLoader, setOpenLoader] = useState(false);
    const [openAlert, setOpenAlert] = useState('');
    const [openClassName, setClassName] = useState('');
    const [openType, setOpenType] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openAlertConfirm, setOpenAlertConfirm] = useState('');
    //const [buttonTextSubmit, setButtonTextSubmit] = useState('Register');
    const [buttonTextSubmit, setButtonTextSubmit] = useState('Submit');
    const [buttonTextSave, setButtonTextSave] = useState('Save');

    const [openImgMSG, setOpenImgMSG] = useState(false);
    const [openAlertImgMSG, setOpenAlertImgMSG] = useState('');
    const [openClassNameImgMSG, setClassNameImgMSG] = useState('');
    const [openTypeImgMSG, setOpenTypeImgMSG] = useState('');

    //const [imageData, setImageData] = useState('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');
    const [imageData, setImageData] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [imageProfileId, setImageProfileId] = useState(0);
    const [errorProfilePhoto, setErrorProfilePhoto] = useState('');
    const [errorTextProfilePhoto, setErrorTextProfilePhoto] = useState('');
    const [candidateData, setcandidateData] = useState([]);

    //function getURLParameter(sParam) {
    //    var sPageURL = window.location.search.substring(1);
    //    var sURLVariables = sPageURL.split('&');
    //    for (var i = 0; i < sURLVariables.length; i++) {
    //        var sParameterName = sURLVariables[i].split('=');
    //        var value = '';
    //        for (var j = 0; j < sParameterName.length; j++) {
    //            if (sParameterName[j] == sParam) {
    //                for (var k = j + 1; k < sParameterName.length; k++) {
    //                    value = value + sParameterName[k];
    //                }
    //                break;
    //            }
    //            //return sParameterName[1];
    //        }
    //        return value;
    //    }
    //}

    const changeFileHandler = (e) => {
        console.log(e.target.files[0]);
        if (imageData != null && imageData.length > 0) {
            setImageFile(null);
            setOpenImgMSG(true);
            setOpenAlertImgMSG("Employee Photo is already uploaded. To change, please delete the existing.");
            setClassNameImgMSG("clr-dark-blue bg-alert");
            setOpenTypeImgMSG("Alert");
        }
        else if (e.target.files.length > 0) {
            var profilephoto = e.target.files[0];
            ValidateProfilePhoto(profilephoto);
        }
        else {
            setImageFile(null);
        }
    }

    function ValidateProfilePhoto(file) {
        let profilephoto = file;
        let extension = profilephoto.name.split('.')[profilephoto.name.split('.').length - 1];
        if (extension.toString().toUpperCase() === 'JPEG' || extension.toString().toUpperCase() === 'JPG' || extension.toString().toUpperCase() === 'PNG') {
            var photosize = profilephoto.size;
            if (photosize > 2097152) {
                setImageFile(null);
                setOpenImgMSG(true);
                setOpenAlertImgMSG("Student Photo size should be 2mb.");
                setClassNameImgMSG("clr-dark-blue bg-alert");
                setOpenTypeImgMSG("Alert");
            }
            else {
                setImageFile(profilephoto);
            }
        }
        else {
            setImageFile(null);
            setOpenImgMSG(true);
            setOpenAlertImgMSG("Student Photo is allow only .jpeg, .jpg, .png");
            setClassNameImgMSG("clr-dark-blue bg-alert");
            setOpenTypeImgMSG("Alert");
        }
    }

    const deleteImageHandler = (e) => {
        deleteEmployeePhoto(imageProfileId);
    }
    //var formData = {
    //    'ProfileId': null,
    //    'UserId': null
    //}
    var fileUploadData = new FormData();
    const uploadHandler = (e) => {
        fileUploadData.append('ProfileId', imageProfileId);
        fileUploadData.append('ImageFile', imageFile);
        fileUploadData.append('Files', imageFile);
        fileUploadData.append('UserId', userDetails?.email);
        //console.log(fileUploadData);
        UploadPhoto(fileUploadData);
    }

    async function UploadPhoto(fileUploadData) {
        setOpenLoader(true);
        const token = siemensToken;
        const options = {
            method: 'put',
            body: fileUploadData,
            headers: {
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            }
        }
        await fetch("Student/UploadEmployeeImage/", options)
            .then(response => response.json())
            .then(data => {
                if (data.result) {
                    setOpenLoader(false);
                    setOpenImgMSG(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlertImgMSG("Image Uploaded Successfully.");
                    setClassNameImgMSG("clr-dark-blue bg-success");
                    setOpenTypeImgMSG("Success");
                    SetStateAfterFileOperation(data?.result);
                }
                else {
                    setOpenLoader(false);
                    setImageFile(null);
                    setOpenImgMSG(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlertImgMSG("Image Upload Failed.");
                    setClassNameImgMSG("clr-dark-blue bg-error");
                    setOpenTypeImgMSG("Error");
                }
            })
            .catch(error => console.log("Error:", error));
        //props.loaderForm(false);
    }

    function SetStateAfterFileOperation(data) {
        console.log(data);
        setImageData(data.imageContent);
        setImageFile(null);
        setImageProfileId(data.profileId);
    }

    async function deleteEmployeePhoto(id) {
        setOpenLoader(true);
        const token = siemensToken;
        await fetch("Student/DeleteEmployeePhoto/" + id, {
            headers: {
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            }
        })
            .then(response => response.json())
            .then(data => {
                setOpenLoader(false);
                if (data.result) {
                    setImageFile(null);
                    setOpenImgMSG(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlertImgMSG("Image Deleted Successfully.");
                    setClassNameImgMSG("clr-dark-blue bg-success");
                    setOpenTypeImgMSG("Success");
                    SetStateAfterFileOperation(data);
                    setErrorProfilePhoto(true);
                    setErrorTextProfilePhoto(true);
                }
                else {
                    setImageFile(null);
                    setOpenImgMSG(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlertImgMSG("Image Deletion Failed.");
                    setClassNameImgMSG("clr-dark-blue bg-error");
                    setOpenTypeImgMSG("Error");
                }
            })
            .catch(error => console.log("Error:", error));
        //props.loaderForm(false);
    }

    function IsValidEmail(value) {
        const exp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return exp.test(String(value).toLowerCase());
    }

    function IsValidMobileNo(value) {
        const exp = /^\d{10}$/;
        return exp.test(value);
    }

    function IsValidYear(value) {
        const exp = /^\d{4}$/;
        return exp.test(value);
    }

    function IsNumeric(value) {
        //const exp = /^[0-9\b]+$/;
        const exp = /^\d+(\.\d{1,2})?$/;
        return exp.test(value);
    }

    function IsAlphabet(value) {
        //const exp = /^[0-9\b]+$/;
        const exp = /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$/;
        return exp.test(value);
    }

    //function ReplaceChars(value) {
    //    return value.replace(/\D/g, "");
    //}

    //var encryptedId = getURLParameter('id');

    const handleClose = () => {
        setOpen(false);
        //if (openType === "Success" && studentId > 0) {
        if (openType === "Success") {
            window.location.href = '/';//StudentHome
        }
    };
    const handleCloseImgMSG = () => {
        setOpenImgMSG(false);
    };


    const handleConfirm = () => {
        clearStates();
        setOpenConfirm(false);
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    };

    async function getGenter() {
        setOpenLoader(true);
        const token = siemensToken;
        const response = await fetch("Student/GetGenderList", {
            headers: {
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            }
        });
        const jsonItems = await response.json();
        //setItemsEmployeeType(jsonItems.map(({ id, name }) => ({ label: name, value: id })));
        setItemsGenter(jsonItems?.result);
        setOpenLoader(false);
    }

    //getCandidateDetails
    // async function getStudentDetails() {
    //     await fetch("Student/GetStudentDetails/" + userDetails?.email, {
    //         headers: {
    //             SiemensToken: siemensToken,
    //             UserEmail: userDetails?.email
    //         }
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             //setIsLoader(false);
    //             //setcandidateData(data);
    //             setStatesStudent(data[0]);
    //             console.log("data:", data[0]);

    //         })
    //         .catch((error) => {
    //             //setIsLoader(false);
    //             console.log("Error:", error);
    //         });
    // }

    async function getQualification() {
        setOpenLoader(true);
        const token = siemensToken;
        const response = await fetch("Student/GetAllQualificationList", {
            headers: {
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            }
        });
        const jsonItems = await response.json();
        //setItemsEmployeeType(jsonItems.map(({ id, name }) => ({ label: name, value: id })));
        setItemsQualification(jsonItems?.result.filter((item) => item.qualification === "10th Class"));
        setItemsQualification9th(jsonItems?.result.filter((item) => item.qualification === "9th Class"));
        setOpenLoader(false);
    }

    async function getTrade() {
        setOpenLoader(true);
        const token = siemensToken;
        const response = await fetch("Student/GetAllTradeList", {
            headers: {
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            }
        });
        const jsonItems = await response.json();
        console.log(jsonItems);
        //setItemsEmployeeType(jsonItems.map(({ id, name }) => ({ label: name, value: id })));
        setItemsTradePrefered(jsonItems?.result);
        setTradePrefered(3);
        setOpenLoader(false);
    }

    const changeEventFirstName = (event) => {
        setFirstName(event.target.value);
        ValidateFirstName(event.target.value);
    };
    const changeEventMiddleName = (event) => {
        setMiddleName(event.target.value);
    };
    const changeEventLastName = (event) => {
        setLastName(event.target.value);
        ValidateLastName(event.target.value);
    };

    const changeEventEmail = (event) => {
        setEmail(event.target.value);
        ValidateEmail(event.target.value);
    };

    const changeEventContactNumber = (event) => {
        setContactNumber(event.target.value);
        ValidateContactNo(event.target.value);
    };

    const changeEventBirthYear = (event) => {
        setBirthYear(event.target.value);
        ValidateBirthYear(event.target.value);
    };

    const changeEventfgContactNumber = (event) => {
        setfgContactNumber(event.target.value);
        setmContactNumber('');
    };

    const changeEventmContactNumber = (event) => {
        setmContactNumber(event.target.value);
        ValidateParentContactNo(event.target.value);
    };

    const changeEventGenter = (event) => {
        setGenter(event.target.value);
        ValidateGender(event.target.value);
    }

    const changeEventfgFirstName = (event) => {
        setfgFirstName(event.target.value);
    };

    const changeEventfgMiddleName = (event) => {
        setfgMiddleName(event.target.value);
    };

    const changeEventfgLastName = (event) => {
        setfgLastName(event.target.value);
    };

    const changeEventmFirstName = (event) => {
        setmFirstName(event.target.value);
    };

    const changeEventmMiddleName = (event) => {
        setmMiddleName(event.target.value);
    };

    const changeEventmLastName = (event) => {
        setmLastName(event.target.value);
    };

    const changeEventPresentAddress = (event) => {
        setPresentAddress(event.target.value);

        ValidatePresentAddress(event.target.value);
        //if (event.target.value.length === 200) {
        //    setErrorTextPresentAddress("Mandatory field");
        //}

    };

    const clickEventClearData = () => {
        setOpenConfirm(true);
        setOpenAlertConfirm("Do you want to clear all the above fields?");
        setClassName("bg-light-green clr-white");
        setOpenType("Confirmation");

    }

    const changeEventQualificationDet = (event) => {
        setQualificationDet(event.target.value);
        setYearofPassing('');
        ValidateQualification(event.target.value);
    }
    const changeEventQualificationDet9th = (event) => {
        setQualificationDet9th(event.target.value);
        setYearofPassing9th('');
        ValidateQualification9th(event.target.value);
    }


    const changeEventyearofPassing = (event) => {
        setYearofPassing(event.target.value);
        ValidateYearOfPassing(event.target.value);
    }
    const changeEventyearofPassing9th = (event) => {
        setYearofPassing9th(event.target.value);
        ValidateYearOfPassing9th(event.target.value);
    }
    const changeEventpercentage = (event) => {
        let a = event.target.value;
        setPercentage(a);
        //ValidatePerOfTotalMarksOnChange(event.target.value);
    }
    const changeEventpercentage9th = (event) => {
        let a = event.target.value;
        setPercentage9th(a);
        //ValidatePerOfTotalMarksOnChange(event.target.value);
    }

    const changeEventPerofMarks = (event) => {
        setTotalperofMarks(event.target.value);
        //ValidateTotalperofMarks(event.target.value);
    }
    const changeEventPerofMarks9th = (event) => {
        setTotalperofMarks(event.target.value);
        //ValidateTotalperofMarks(event.target.value);
    }

    const changeEventNameofboard = (event) => {
        setNameofBoard(event.target.value);
        ValidateNameofBoard(event.target.value);
    }
    const changeEventNameofboard9th = (event) => {
        setNameofBoard9th(event.target.value);
        ValidateNameofBoard9th(event.target.value);
    }

    const changeEventEnglishObtained = (event) => {
        let engObt = event.target.value;
        setEnglishObtained(engObt);
        //engObt = parseFloat(event.target.value).toFixed(2);
        //ValidateEnglishObtained(engObt);
        //calculatePercentage("E", engObt, englishOutof);
    }
    const changeEventEnglishObtained9th = (event) => {
        let engObt = event.target.value;
        setEnglishObtained9th(engObt);
        //engObt = parseFloat(event.target.value).toFixed(2);
        //ValidateEnglishObtained(engObt);
        //calculatePercentage("E", engObt, englishOutof);
    }

    const blurEventpercentage = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setPercentage(Obt);

        ValidatePerOfTotalMarksOnChange(Obt);
    }
    const blurEventpercentage9th = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setPercentage9th(Obt);

        ValidatePerOfTotalMarksOnChange9th(Obt);
    }

    const blurEventEnglishObtained = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setEnglishObtained(Obt);
        ValidateEnglishObtained(Obt);
        calculatePercentage("E", Obt, englishOutof);
    }
    const blurEventEnglishObtained9th = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setEnglishObtained9th(Obt);
        ValidateEnglishObtained9th(Obt);
        calculatePercentage9th("E", Obt, englishOutof9th);
    }

    const changeEventEnglishOutof = (event) => {
        let englishOutof = event.target.value;
        ValidateEnglishOutOf(englishOutof);
        setenglishOutof(englishOutof);
        calculatePercentage("E", englishObtained, event.target.value);
    }
    const changeEventEnglishOutof9th = (event) => {
        let englishOutof = event.target.value;
        ValidateEnglishOutOf9th(englishOutof);
        setenglishOutof9th(englishOutof);
        calculatePercentage9th("E", englishObtained9th, event.target.value);
    }

    const changeEventEnglishPerofMarks = (event) => {
        setenglishperofMarks(event.target.value);
    }
    const changeEventEnglishPerofMarks9th = (event) => {
        setenglishperofMarks9th(event.target.value);
    }

    const changeEventMathmaticsObtained = (event) => {
        setMathmaticsObtained(event.target.value);
        //ValidateMathematicsObtained(event.target.value);
        //calculatePercentage("M", event.target.value, mathmaticsOutof);
    }
    const changeEventMathmaticsObtained9th = (event) => {
        setMathmaticsObtained9th(event.target.value);
        //ValidateMathematicsObtained(event.target.value);
        //calculatePercentage("M", event.target.value, mathmaticsOutof);
    }

    const blurEventMathmaticsObtained = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setMathmaticsObtained(Obt);
        ValidateMathematicsObtained(Obt);
        calculatePercentage("M", Obt, mathmaticsOutof);
    }
    const blurEventMathmaticsObtained9th = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setMathmaticsObtained9th(Obt);
        ValidateMathematicsObtained9th(Obt);
        calculatePercentage9th("M", Obt, mathmaticsOutof9th);
    }

    const changeEventMathmaticsOutof = (event) => {
        ValidateMathematicsOutof(event.target.value);
        setMathmaticsOutof(event.target.value);
        calculatePercentage("M", mathmaticsObtained, event.target.value);
    }
    const changeEventMathmaticsOutof9th = (event) => {
        ValidateMathematicsOutof9th(event.target.value);
        setMathmaticsOutof9th(event.target.value);
        calculatePercentage9th("M", mathmaticsObtained9th, event.target.value);
    }

    const changeEventMathmaticsPerofMarks = (event) => {
        setMathmaticsperofMarks(event.target.value);
    }
    const changeEventMathmaticsPerofMarks9th = (event) => {
        setMathmaticsperofMarks9th(event.target.value);
    }

    const changeEventScienceObtained = (event) => {
        setScienceObtained(event.target.value);
        //ValidateScienceObtained(event.target.value);
        //calculatePercentage("S", event.target.value, scienceOutof);
    }
    const changeEventScienceObtained9th = (event) => {
        setScienceObtained9th(event.target.value);
        //ValidateScienceObtained(event.target.value);
        //calculatePercentage("S", event.target.value, scienceOutof);
    }

    const blurEventScienceObtained = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setScienceObtained(Obt);
        ValidateScienceObtained(Obt);
        calculatePercentage("S", Obt, scienceOutof);
    }
    const blurEventScienceObtained9th = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setScienceObtained9th(Obt);
        ValidateScienceObtained9th(Obt);
        calculatePercentage9th("S", Obt, scienceOutof9th);
    }

    const changeEventScienceOutof = (event) => {
        setScienceOutof(event.target.value);
        ValidateScienceOutOf(event.target.value);
        calculatePercentage("S", scienceObtained, event.target.value);
    }
    const changeEventScienceOutof9th = (event) => {
        setScienceOutof9th(event.target.value);
        ValidateScienceOutOf9th(event.target.value);
        calculatePercentage9th("S", scienceObtained9th, event.target.value);
    }

    const changeEventSciencePerofMarks = (event) => {
        setScienceperofMarks(event.target.value);
    }
    const changeEventSciencePerofMarks9th = (event) => {
        setScienceperofMarks9th(event.target.value);
    }

    const changeEventTotalObtained = (event) => {
        //ValidateTotalObtained(event.target.value)
        setTotalObtained(event.target.value);
        //calculatePercentage("T", event.target.value, totalOutof);
    }
    const changeEventTotalObtained9th = (event) => {
        //ValidateTotalObtained(event.target.value)
        setTotalObtained9th(event.target.value);
        //calculatePercentage("T", event.target.value, totalOutof);
    }

    const blurEventTotalObtained = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setTotalObtained(Obt);
        ValidateTotalObtained(Obt)
        calculatePercentage("T", Obt, totalOutof);
    }
    const blurEventTotalObtained9th = (event) => {
        let Obt = parseFloat(event.target.value).toFixed(2);
        if (event.target.value == "") {
            Obt = 0;
        }
        setTotalObtained9th(Obt);
        ValidateTotalObtained9th(Obt)
        calculatePercentage9th("T", Obt, totalOutof9th);
    }

    const changeEventTotalOutof = (event) => {
        ValidateTotalOutOf(event.target.value);
        setTotalOutof(event.target.value);
        calculatePercentage("T", totalObtained, event.target.value);
    }
    const changeEventTotalOutof9th = (event) => {
        ValidateTotalOutOf9th(event.target.value);
        setTotalOutof9th(event.target.value);
        calculatePercentage9th("T", totalObtained9th, event.target.value);
    }

    const changeEventTradePrefered = (event) => {
        setTradePrefered(event.target.value);
    }
    function calculatePercentage9th(sub, obtmarks, outofmarks) {
        let percentage = 0;
        if (Number(outofmarks) > 0) {
            percentage = parseFloat(obtmarks) / parseFloat(outofmarks);
            percentage = percentage * 100;
            percentage = parseFloat(percentage).toFixed(2);
            if (percentage == 'NaN') {
                percentage = "";
            }
        }
        if (sub === "E") {
            setenglishperofMarks9th(percentage);
            if (percentage > 100 || percentage < 0) {
                seterrorEnglishPerofMarks9th(true);
                seterrorTextEnglishPerofMarks9th("% should be in range of 0 to 100");
            }
            else {
                seterrorEnglishPerofMarks9th(false);
                seterrorTextEnglishPerofMarks9th("");
            }
        }
        if (sub === "M") {
            setMathmaticsperofMarks9th(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorMathmaticsPerofMarks9th(true);
                setErrorTextMathmaticsPerofMarks9th("% should be in range of 0 to 100");
            }
            else {
                setErrorMathmaticsPerofMarks9th(false);
                setErrorTextMathmaticsPerofMarks9th("");
            }
        }
        if (sub === "S") {
            setScienceperofMarks9th(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorSciencePerofMarks9th(true);
                setErrorTextSciencePerofMarks9th("% should be in range of 0 to 100");
            }
            else {
                setErrorSciencePerofMarks9th(false);
                setErrorTextSciencePerofMarks9th("");
            }
        }
        if (sub === "T") {
            setTotalperofMarks9th(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorTotalPerofMarks9th(true);
                //setErrorTextTotalObtained("% should be in range of 0 to 100");
                setErrorTotalPerofMarks9th("% should be in range of 0 to 100");
            }
            else {
                setErrorTotalPerofMarks9th(false);
                setErrorTotalPerofMarks9th("");
            }
            ValidateTotalperofMarks9th(percentage);
        }
    }

    function calculatePercentage(sub, obtmarks, outofmarks) {
        let percentage = 0;
        if (Number(outofmarks) > 0) {
            percentage = parseFloat(obtmarks) / parseFloat(outofmarks);
            percentage = percentage * 100;
            percentage = parseFloat(percentage).toFixed(2);
            if (percentage == 'NaN') {
                percentage = "";
            }
        }
        if (sub === "E") {
            setenglishperofMarks(percentage);
            if (percentage > 100 || percentage < 0) {
                seterrorEnglishPerofMarks(true);
                seterrorTextEnglishPerofMarks("% should be in range of 0 to 100");
            }
            else {
                seterrorEnglishPerofMarks(false);
                seterrorTextEnglishPerofMarks("");
            }
        }
        if (sub === "M") {
            setMathmaticsperofMarks(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorMathmaticsPerofMarks(true);
                setErrorTextMathmaticsPerofMarks("% should be in range of 0 to 100");
            }
            else {
                setErrorMathmaticsPerofMarks(false);
                setErrorTextMathmaticsPerofMarks("");
            }
        }
        if (sub === "S") {
            setScienceperofMarks(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorSciencePerofMarks(true);
                setErrorTextSciencePerofMarks("% should be in range of 0 to 100");
            }
            else {
                setErrorSciencePerofMarks(false);
                setErrorTextSciencePerofMarks("");
            }
        }
        if (sub === "T") {
            setTotalperofMarks(percentage);
            if (percentage > 100 || percentage < 0) {
                setErrorTotalPerofMarks(true);
                //setErrorTextTotalObtained("% should be in range of 0 to 100");
                setErrorTotalPerofMarks("% should be in range of 0 to 100");
            }
            else {
                setErrorTotalPerofMarks(false);
                setErrorTotalPerofMarks("");
            }
            ValidateTotalperofMarks(percentage);
        }
    }
    const clickEventSaveAsDraft = async () => {
        setOpenLoader(true);
        const formData = {
            'StudentId': studentId,
            'FirstName': firstName,
            'MiddleName': middleName,
            'LastName': lastName,
            'ContactNumber': ContactNumber,
            'BirthYear': birthYear,
            'GenderId': genter,
            'Email': email,
            'FGFirstName': fgfirstName,
            'FGMiddleName': fgmiddleName,
            'FGLastName': fglastName,
            'MFirstName': mfirstName,
            'MMiddleName': mmiddleName,
            'MLastName': mlastName,
            'FGContactNo': fgContactNumber,
            'MContactNo': mContactNumber,
            'PresentAddress': presentAddress,
            'CreatedBy': userDetails?.email,
            'ModifiedBy': userDetails?.email,
            'QualificationId': qualificationDet,
            'YearOfPassing': yearofPassing,
            'PercentageOfTotalMarks': percentage,
            'NameOfBoard': nameofboard,
            'EnglishObtainedMarks': englishObtained,
            'MathematicsObtainedMarks': mathmaticsObtained,
            'ScienceObtainedMarks': scienceObtained,
            'TotalObtainedMarks': totalObtained,
            'EnglishOutOfMarks': englishOutof,
            'MathematicsOutofMarks': mathmaticsOutof,
            'ScienceOutOfMarks': scienceOutof,
            'TotalOutOfMarks': totalOutof,
            'EnglishPercentage': englishperofMarks,
            'MathematicsPercentage': mathmaticsperofMarks,
            'SciencePercentage': scienceperofMarks,
            'TotalPercentage': totalperofMarks,
            //9th variables
            'QualificationId9th': qualificationDet9th,
            'YearOfPassing9th': yearofPassing9th,
            'PercentageOfTotalMarks9th': percentage9th,
            'NameOfBoard9th': nameofboard9th,
            'EnglishObtainedMarks9th': englishObtained9th,
            'MathematicsObtainedMarks9th': mathmaticsObtained9th,
            'ScienceObtainedMarks9th': scienceObtained9th,
            'TotalObtainedMarks9th': totalObtained9th,
            'EnglishOutOfMarks9th': englishOutof9th,
            'MathematicsOutofMarks9th': mathmaticsOutof9th,
            'ScienceOutOfMarks9th': scienceOutof9th,
            'TotalOutOfMarks9th': totalOutof9th,
            'EnglishPercentage9th': englishperofMarks9th,
            'MathematicsPercentage9th': mathmaticsperofMarks9th,
            'SciencePercentage9th': scienceperofMarks9th,
            'TotalPercentage9th': totalperofMarks9th,
            'TradeId': tradePrefered,
            'ProfileId': imageProfileId,
            'FGMContactType': fgContactNumber,
            'IsSubmitted': 0
        }
        if (ValidateCommonDetails(formData)) {
            var candidateData = JSON.stringify(formData);
            //------Update Student Details --------------
            if (studentId > 0) {
                var candidateData = JSON.stringify(formData);
                DraftUpdateCandidate(candidateData);

            }
            //------Save Student Details --------------
            else {
                var candidateData = JSON.stringify(formData);
                DraftRegisterCandidate(candidateData);
            }

        }
        else {
            setOpenLoader(false);
            setOpen(true);
            setOpenAlert("Form validation unsuccessful. Please check the error messages.");
            setClassName("bg-red clr-white");
            setOpenType("Alert");
        }
    }

    const clickEventRegisterCandidate = async () => {
        setOpenLoader(true);
        const formData = {
            'StudentId': studentId,
            'FirstName': firstName,
            'MiddleName': middleName,
            'LastName': lastName,
            'ContactNumber': ContactNumber,
            'BirthYear': birthYear,
            'GenderId': genter,
            'Email': email,
            'FGFirstName': fgfirstName,
            'FGMiddleName': fgmiddleName,
            'FGLastName': fglastName,
            'MFirstName': mfirstName,
            'MMiddleName': mmiddleName,
            'MLastName': mlastName,
            'FGContactNo': fgContactNumber,
            'MContactNo': mContactNumber,
            'PresentAddress': presentAddress,
            'CreatedBy': userDetails?.email,
            'ModifiedBy': userDetails?.email,
            'QualificationId': qualificationDet,
            'YearOfPassing': yearofPassing,
            'PercentageOfTotalMarks': percentage,
            'NameOfBoard': nameofboard,
            'EnglishObtainedMarks': englishObtained,
            'MathematicsObtainedMarks': mathmaticsObtained,
            'ScienceObtainedMarks': scienceObtained,
            'TotalObtainedMarks': totalObtained,
            'EnglishOutOfMarks': englishOutof,
            'MathematicsOutofMarks': mathmaticsOutof,
            'ScienceOutOfMarks': scienceOutof,
            'TotalOutOfMarks': totalOutof,
            'EnglishPercentage': englishperofMarks,
            'MathematicsPercentage': mathmaticsperofMarks,
            'SciencePercentage': scienceperofMarks,
            'TotalPercentage': totalperofMarks,
            //9th variables
            'QualificationId9th': qualificationDet9th,
            'YearOfPassing9th': yearofPassing9th,
            'PercentageOfTotalMarks9th': percentage9th,
            'NameOfBoard9th': nameofboard9th,
            'EnglishObtainedMarks9th': englishObtained9th,
            'MathematicsObtainedMarks9th': mathmaticsObtained9th,
            'ScienceObtainedMarks9th': scienceObtained9th,
            'TotalObtainedMarks9th': totalObtained9th,
            'EnglishOutOfMarks9th': englishOutof9th,
            'MathematicsOutofMarks9th': mathmaticsOutof9th,
            'ScienceOutOfMarks9th': scienceOutof9th,
            'TotalOutOfMarks9th': totalOutof9th,
            'EnglishPercentage9th': englishperofMarks9th,
            'MathematicsPercentage9th': mathmaticsperofMarks9th,
            'SciencePercentage9th': scienceperofMarks9th,
            'TotalPercentage9th': totalperofMarks9th,
            'TradeId': tradePrefered,
            'ProfileId': imageProfileId,
            'FGMContactType': fgContactNumber,
            'IsSubmitted': 1
        }
        if (ValidateFormFields(formData)) {
            var candidateData = JSON.stringify(formData);
            if (studentId > 0) {
                var candidateData = JSON.stringify(formData);
                UpdateCandidate(candidateData);
            }
            //------Save Student Details --------------
            else {
                var candidateData = JSON.stringify(formData);
                RegisterCandidate(candidateData);

            }
        }
        else {
            setOpenLoader(false);
            setOpen(true);
            setOpenAlert("Form validation unsuccessful. Please check the error messages.");
            setClassName("bg-red clr-white");
            setOpenType("Alert");
        }
    }

    function ValidateFirstName(FirstName) {

        if (FirstName == null || FirstName == '') {
            setErrorFirstName(true);
            setErrorTextFirstName("Mandatory field");
            return true;
        }
        else if (!IsAlphabet(FirstName)) {
            setErrorFirstName(true);
            setErrorTextFirstName("Enter valid name");
            return true;

        }


        else {
            setErrorFirstName(false);
            setErrorTextFirstName("");
            return false;
        }
    }

    function ValidateLastName(LastName) {
        if (LastName == null || LastName == '') {
            setErrorLastName(true);
            setErrorTextLastName("Mandatory field");
            return true;
        }
        else if (!IsAlphabet(LastName)) {
            setErrorLastName(true);
            setErrorTextLastName("Enter valid name");
            return true;

        }
        else {
            setErrorLastName(false);
            setErrorTextLastName("");
            return false;
        }
    }

    function ValidateEmail(Email) {
        if (Email == null || Email == '') {
            setErrorEmail(true);
            setErrorTextEmail("Mandatory field");
            return true;
        }
        else {
            if (!IsValidEmail(Email)) {
                setErrorEmail(true);
                setErrorTextEmail("Email format invalid");
                return true;
            }
            else {
                setErrorEmail(false);
                setErrorTextEmail("");
                return false;
            }
        }
    }

    function ValidateContactNo(ContactNumber) {
        if (ContactNumber == null || ContactNumber == '') {
            setErrorContactNumber(true);
            setErrorTextContactNumber('Mandatory field');
            return true;
        }
        else {
            if (!IsValidMobileNo(ContactNumber)) {
                setErrorContactNumber(true);
                setErrorTextContactNumber("Mobile Number format invalid");
                return true;
            }
            else {
                setErrorContactNumber(false);
                setErrorTextContactNumber("");
                return false;
            }
        }
    }

    function ValidateParentContactNo(MContactNo) {
        if (MContactNo == null || MContactNo == '') {
            setErrormContactNumber(true);
            setErrorTextmContactNumber('Mandatory field');
            return true;
        }
        else {
            if (!IsValidMobileNo(MContactNo)) {
                setErrormContactNumber(true);
                setErrorTextmContactNumber("Mobile Number invalid");
                return true;
            }
            else {
                setErrormContactNumber(false);
                setErrorTextmContactNumber("");
                return false;
            }
        }
    }

    function ValidateGender(GenderId) {
        if (GenderId == null || GenderId == '') {
            setErrorGender(true);
            setErrorTextGender("Mandatory field");
            return true;
        }
        else {
            setErrorGender(false);
            setErrorTextGender("");
            return false;
        }
    }

    function ValidateBirthYear(BirthYear) {
        if (BirthYear == null || BirthYear == '') {
            setErrorBirthYear(true);
            setErrorTextBirthYear("Mandatory field");
            return true;
        }
        else {
            if (!IsValidYear(BirthYear)) {
                setErrorBirthYear(true);
                setErrorTextBirthYear("Birth Year invalid");
                return true;
            }
            else {
                var minYear = 2007;
                //var maxYear = minYear + 1;
                var currentYear = new Date().getFullYear();
                if (Number(BirthYear) < minYear) {
                    setErrorBirthYear(true);
                    setErrorTextBirthYear("Born after 01.01.2007 can apply");
                    return true;
                }
                else {
                    if (Number(BirthYear) >= currentYear) {
                        setErrorBirthYear(true);
                        setErrorTextBirthYear("Birth year can't be current year");
                        return true;
                    }
                    else {
                        setErrorBirthYear(false);
                        setErrorTextBirthYear("");
                        return false;
                    }
                }
            }
        }
    }

    function ValidatePresentAddress(PresentAddress) {
        if (PresentAddress == null || PresentAddress == '') {
            setErrorPresentAddress(true);
            setErrorTextPresentAddress("Mandatory field");
            return true;
        }
        else if (PresentAddress.length >= 150) {
            setErrorPresentAddress(true);
            setErrorTextPresentAddress("Max 150 characters");
            return true;
        }
        else {
            setErrorPresentAddress(false);
            setErrorTextPresentAddress("");
            return false;
        }
    }

    function ValidateQualification(QualificationId) {
        if (QualificationId == null || QualificationId == '') {
            setErrorQualification(true);
            setErrorTextQualification("Mandatory field");
            return true;
        }
        else {
            //let qualification = QualificationId;
            //let curYear = new Date().getFullYear();
            //if (Number(qualification) == 2) {
            //    curYear = curYear - 1;
            //}
            //if (yearofPassing > curYear || yearofPassing < curYear) {
            //    setErrorYearofPassing(true);
            //    setErrorTextYearofPassing("Passing year allow only " + curYear);
            //    return true;
            //}
            //else {
            //    setErrorYearofPassing("");
            //    setErrorTextYearofPassing("");
            //}
            setErrorQualification(false);
            setErrorTextQualification("");
            return false;
        }
    }
    function ValidateQualification9th(QualificationId) {
        if (QualificationId == null || QualificationId == '') {
            setErrorQualification9th(true);
            setErrorTextQualification9th("Mandatory field");
            return true;
        }
        else {
            //let qualification = QualificationId;
            //let curYear = new Date().getFullYear();
            //if (Number(qualification) == 2) {
            //    curYear = curYear - 1;
            //}
            //if (yearofPassing > curYear || yearofPassing < curYear) {
            //    setErrorYearofPassing(true);
            //    setErrorTextYearofPassing("Passing year allow only " + curYear);
            //    return true;
            //}
            //else {
            //    setErrorYearofPassing("");
            //    setErrorTextYearofPassing("");
            //}
            setErrorQualification9th(false);
            setErrorTextQualification9th("");
            return false;
        }
    }

    function ValidateYearOfPassing(YearOfPassing) {
        if (YearOfPassing == null || YearOfPassing == '') {
            setErrorYearofPassing(true);
            setErrorTextYearofPassing("Mandatory field");
            return true;
        }
        else {
            if (!IsValidYear(YearOfPassing)) {
                setErrorYearofPassing(true);
                setErrorTextYearofPassing("Year of passing invalid");
                return true;
            }
            else {
                let qualification = qualificationDet;
                let curYear = new Date().getFullYear();
                if (Number(qualification) == 2) {
                    curYear = curYear - 1;
                }
                if (YearOfPassing > curYear || YearOfPassing < curYear) {
                    setErrorYearofPassing(true);
                    setErrorTextYearofPassing("Year of passing allowed is only " + curYear);
                    return true;
                }
                else {
                    setErrorYearofPassing(false);
                    setErrorTextYearofPassing("");
                    return false;
                }
            }
        }
    }
    function ValidateYearOfPassing9th(YearOfPassing) {
        if (YearOfPassing == null || YearOfPassing == '') {
            setErrorYearofPassing9th(true);
            setErrorTextYearofPassing9th("Mandatory field");
            return true;
        }
        else {
            if (!IsValidYear(YearOfPassing)) {
                setErrorYearofPassing9th(true);
                setErrorTextYearofPassing9th("Year of passing invalid");
                return true;
            }
            else {
                let qualification = qualificationDet9th;
                let curYear = new Date().getFullYear();
                if (Number(qualification) == 2) {
                    curYear = curYear - 1;
                }
                if (YearOfPassing > curYear || YearOfPassing < curYear) {
                    setErrorYearofPassing9th(true);
                    setErrorTextYearofPassing9th("Year of passing allowed is only " + curYear);
                    return true;
                }
                else {
                    setErrorYearofPassing9th(false);
                    setErrorTextYearofPassing9th("");
                    return false;
                }
            }
        }
    }
    function ValidatePerOfTotalMarks9th(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorPercentage9th(true);
            setErrorTextPercentage9th("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(PercentageOfTotalMarks).toFixed(2);
            let b = parseFloat(totalperofMarks9th).toFixed(2);
            if (a !== b) {
                setErrorPercentage9th(true);
                setErrorTextPercentage9th("% of Total should be same in both places");
                return true;
            }
            if (a < 0 || a > 100) {
                setErrorPercentage9th(true);
                setErrorTextPercentage9th("% should be in range of 0 to 100");
                return true;
            }
            else {
                if (!IsNumeric(PercentageOfTotalMarks)) {
                    setErrorPercentage9th(true);
                    setErrorTextPercentage9th("Enter valid percentage");
                    return true;
                }
                else {
                    if (a > 100) {
                        setErrorPercentage9th(true);
                        setErrorTextPercentage9th("% of Total should less than or equal to 100");
                        setErrorTotalPerofMarks9th(true);
                        setErrorTextTotalPerofMarks9th("% of Total should less than or equal to 100");
                        return true;
                    }
                    setErrorPercentage9th(false);
                    setErrorTextPercentage9th("");
                    return false;
                }
            }
        }
    }


    function ValidatePerOfTotalMarks(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorPercentage(true);
            setErrorTextPercentage("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(PercentageOfTotalMarks).toFixed(2);
            let b = parseFloat(totalperofMarks).toFixed(2);
            if (a !== b) {
                setErrorPercentage(true);
                setErrorTextPercentage("% of Total should be same in both places");
                return true;
            }
            if (a < 0 || a > 100) {
                setErrorPercentage(true);
                setErrorTextPercentage("% should be in range of 0 to 100");
                return true;
            }
            else {
                if (!IsNumeric(PercentageOfTotalMarks)) {
                    setErrorPercentage(true);
                    setErrorTextPercentage("Enter valid percentage");
                    return true;
                }
                else {
                    if (a > 100) {
                        setErrorPercentage(true);
                        setErrorTextPercentage("% of Total should less than or equal to 100");
                        setErrorTotalPerofMarks(true);
                        setErrorTextTotalPerofMarks("% of Total should less than or equal to 100");
                        return true;
                    }
                    setErrorPercentage(false);
                    setErrorTextPercentage("");
                    return false;
                }
            }
        }
    }

    function ValidatePerOfTotalMarksOnChange(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorPercentage(true);
            setErrorTextPercentage("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(PercentageOfTotalMarks).toFixed(2);
            let b = parseFloat(totalperofMarks).toFixed(2);
            if (!IsNumeric(PercentageOfTotalMarks)) {
                setErrorPercentage(true);
                setErrorTextPercentage("Enter valid percentage");
                return true;
            }
            else {
                setErrorPercentage(false);
                setErrorTextPercentage("");
                if (a < 0 || a > 100) {
                    setErrorPercentage(true);
                    setErrorTextPercentage("% should be in range of 0 to 100");
                    return true;
                }
                if (a == b && totalObtained > 0 && totalOutof > 0) {
                    setErrorPercentage(false);
                    setErrorTextPercentage("");
                    setErrorTotalPerofMarks(false);
                    setErrorTextTotalPerofMarks("");
                    return true;
                }
                return false;
            }
        }
    }
    function ValidatePerOfTotalMarksOnChange9th(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorPercentage9th(true);
            setErrorTextPercentage9th("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(PercentageOfTotalMarks).toFixed(2);
            let b = parseFloat(totalperofMarks9th).toFixed(2);
            if (!IsNumeric(PercentageOfTotalMarks)) {
                setErrorPercentage9th(true);
                setErrorTextPercentage9th("Enter valid percentage");
                return true;
            }
            else {
                setErrorPercentage9th(false);
                setErrorTextPercentage9th("");
                if (a < 0 || a > 100) {
                    setErrorPercentage9th(true);
                    setErrorTextPercentage9th("% should be in range of 0 to 100");
                    return true;
                }
                if (a == b && totalObtained9th > 0 && totalOutof9th > 0) {
                    setErrorPercentage9th(false);
                    setErrorTextPercentage9th("");
                    setErrorTotalPerofMarks9th(false);
                    setErrorTextTotalPerofMarks9th("");
                    return true;
                }
                return false;
            }
        }
    }


    function ValidateTotalperofMarks(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorTotalPerofMarks(true);
            setErrorTextTotalPerofMarks("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(percentage).toFixed(2);
            let b = parseFloat(PercentageOfTotalMarks).toFixed(2);
            if (a !== b) {
                setErrorPercentage(true);
                setErrorTextPercentage("% of Total should be same in both places");
                setErrorTotalPerofMarks(true);
                setErrorTextTotalPerofMarks("% of Total should be same in both places");
                return true;
            }
            else {
                setErrorPercentage(false);
                setErrorTextPercentage("");
                setErrorTotalPerofMarks(false);
                setErrorTextTotalPerofMarks("");
                return false;
            }
        }
    }
    function ValidateTotalperofMarks9th(PercentageOfTotalMarks) {
        if (PercentageOfTotalMarks == null || PercentageOfTotalMarks == '') {
            setErrorTotalPerofMarks9th(true);
            setErrorTextTotalPerofMarks9th("Mandatory field");
            return true;
        }
        else {
            let a = parseFloat(percentage9th).toFixed(2);
            let b = parseFloat(PercentageOfTotalMarks).toFixed(2);
            if (a !== b) {
                setErrorPercentage9th(true);
                setErrorTextPercentage9th("% of Total should be same in both places");
                setErrorTotalPerofMarks9th(true);
                setErrorTextTotalPerofMarks9th("% of Total should be same in both places");
                return true;
            }
            else {
                setErrorPercentage9th(false);
                setErrorTextPercentage9th("");
                setErrorTotalPerofMarks9th(false);
                setErrorTextTotalPerofMarks9th("");
                return false;
            }
        }
    }


    function ValidateNameofBoard(NameOfBoard) {
        if (NameOfBoard == null || NameOfBoard == '') {
            setErrorNameofboard(true);
            setErrorTextNameofboard("Mandatory field");
            return true;
        }
        else {
            if (NameOfBoard.toString().length > 100) {
                setErrorNameofboard(true);
                setErrorTextNameofboard("Maximum length 100 char.");
                return true;
            }
            setErrorNameofboard(false);
            setErrorTextNameofboard("");
            return false;
        }
    }
    function ValidateNameofBoard9th(NameOfBoard) {
        if (NameOfBoard == null || NameOfBoard == '') {
            setErrorNameofboard9th(true);
            setErrorTextNameofboard9th("Mandatory field");
            return true;
        }
        else {
            if (NameOfBoard.toString().length > 100) {
                setErrorNameofboard9th(true);
                setErrorTextNameofboard9th("Maximum length 100 char.");
                return true;
            }
            setErrorNameofboard9th(false);
            setErrorTextNameofboard9th("");
            return false;
        }
    }

    function ValidateTotalObtained(TotalObtainedMarks) {
        if (TotalObtainedMarks == null || Number(TotalObtainedMarks) == 0) {
            setErrorTotalObtained(true);
            setErrorTextTotalObtained("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(TotalObtainedMarks)) {
                setErrorTotalObtained(true);
                setErrorTextTotalObtained("Enter valid Obtained marks");
                setErrorTotalPerofMarks(true);
                setErrorTextTotalPerofMarks("");
                return true;
            }
            else {
                let a = parseFloat(TotalObtainedMarks);
                let b = parseFloat(totalOutof);
                if (a <= 0) {
                    setErrorTotalObtained(true);
                    setErrorTextTotalObtained("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorTotalObtained(true);
                    setErrorTextTotalObtained("Marks can't be greater than out of marks");
                    return true;
                }
                ////if (a > 100) {
                ////    setErrorTotalObtained(true);
                ////    setErrorTextTotalObtained("Marks can't be greater than out of marks");
                ////    return true;
                ////}
                setErrorTotalObtained(false);
                setErrorTextTotalObtained("");
                return false;
            }
        }
    }
    function ValidateTotalObtained9th(TotalObtainedMarks) {
        if (TotalObtainedMarks == null || Number(TotalObtainedMarks) == 0) {
            setErrorTotalObtained9th(true);
            setErrorTextTotalObtained9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(TotalObtainedMarks)) {
                setErrorTotalObtained9th(true);
                setErrorTextTotalObtained9th("Enter valid Obtained marks");
                setErrorTotalPerofMarks9th(true);
                setErrorTextTotalPerofMarks9th("");
                return true;
            }
            else {
                let a = parseFloat(TotalObtainedMarks);
                let b = parseFloat(totalOutof9th);
                if (a <= 0) {
                    setErrorTotalObtained9th(true);
                    setErrorTextTotalObtained9th("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorTotalObtained9th(true);
                    setErrorTextTotalObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                ////if (a > 100) {
                ////    setErrorTotalObtained(true);
                ////    setErrorTextTotalObtained("Marks can't be greater than out of marks");
                ////    return true;
                ////}
                setErrorTotalObtained9th(false);
                setErrorTextTotalObtained9th("");
                return false;
            }
        }
    }

    function ValidateTotalOutOf(TotalOutOfMarks) {
        if (TotalOutOfMarks == null || Number(TotalOutOfMarks) == 0) {
            setErrorTotalOutof(true);
            setErrorTextTotalOutof("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(TotalOutOfMarks)) {
                setErrorTotalOutof(true);
                setErrorTextTotalOutof("Enter valid Out of marks");
                return true;
            }
            else {
                ////let a = parseFloat(TotalOutOfMarks);
                ////if (a > 100) {
                ////    setErrorTotalOutof(true);
                ////    setErrorTextTotalOutof("Enter Out of marks less than equal to 100");
                ////    return true;
                ////}
                ////setErrorTotalObtained(false);
                ////setErrorTextTotalObtained("");
                //setErrorTotalOutof(false);
                //setErrorTextTotalOutof("");
                //return false;
                setErrorTotalOutof(false);
                setErrorTextTotalOutof("");

                let a = parseFloat(totalObtained);
                let b = parseFloat(TotalOutOfMarks);
                if (a > b) {
                    setErrorTotalObtained(true);
                    setErrorTextTotalObtained("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorTotalObtained(false);
                    setErrorTextTotalObtained("");
                    return false;
                }
            }
        }
    }
    function ValidateTotalOutOf9th(TotalOutOfMarks) {
        if (TotalOutOfMarks == null || Number(TotalOutOfMarks) == 0) {
            setErrorTotalOutof9th(true);
            setErrorTextTotalOutof9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(TotalOutOfMarks)) {
                setErrorTotalOutof9th(true);
                setErrorTextTotalOutof9th("Enter valid Out of marks");
                return true;
            }
            else {
                ////let a = parseFloat(TotalOutOfMarks);
                ////if (a > 100) {
                ////    setErrorTotalOutof(true);
                ////    setErrorTextTotalOutof("Enter Out of marks less than equal to 100");
                ////    return true;
                ////}
                ////setErrorTotalObtained(false);
                ////setErrorTextTotalObtained("");
                //setErrorTotalOutof(false);
                //setErrorTextTotalOutof("");
                //return false;
                setErrorTotalOutof9th(false);
                setErrorTextTotalOutof9th("");

                let a = parseFloat(totalObtained9th);
                let b = parseFloat(TotalOutOfMarks);
                if (a > b) {
                    setErrorTotalObtained9th(true);
                    setErrorTextTotalObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorTotalObtained9th(false);
                    setErrorTextTotalObtained9th("");
                    return false;
                }
            }
        }
    }

    function ValidateMathematicsObtained9th(MathematicsObtainedMarks) {
        if (MathematicsObtainedMarks == null || Number(MathematicsObtainedMarks) == 0) {
            seterrorMathmaticsObtained9th(true);
            seterrorTextMathmaticsObtained9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(MathematicsObtainedMarks)) {
                seterrorMathmaticsObtained9th(true);
                seterrorTextMathmaticsObtained9th("Enter valid Obtained marks");

                setErrorMathmaticsPerofMarks9th(true);
                setErrorTextMathmaticsPerofMarks9th("");
                return true;
            }
            else {
                let a = parseFloat(MathematicsObtainedMarks);
                let b = parseFloat(mathmaticsOutof9th);
                if (a <= 0) {
                    seterrorMathmaticsObtained9th(true);
                    seterrorTextMathmaticsObtained9th("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    seterrorMathmaticsObtained9th(true);
                    seterrorTextMathmaticsObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    seterrorMathmaticsObtained(true);
                //    seterrorTextMathmaticsObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                seterrorMathmaticsObtained9th(false);
                seterrorTextMathmaticsObtained9th("");
                return false;
            }
        }
    }

    function ValidateMathematicsObtained(MathematicsObtainedMarks) {
        if (MathematicsObtainedMarks == null || Number(MathematicsObtainedMarks) == 0) {
            seterrorMathmaticsObtained(true);
            seterrorTextMathmaticsObtained("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(MathematicsObtainedMarks)) {
                seterrorMathmaticsObtained(true);
                seterrorTextMathmaticsObtained("Enter valid Obtained marks");

                setErrorMathmaticsPerofMarks(true);
                setErrorTextMathmaticsPerofMarks("");
                return true;
            }
            else {
                let a = parseFloat(MathematicsObtainedMarks);
                let b = parseFloat(mathmaticsOutof);
                if (a <= 0) {
                    seterrorMathmaticsObtained(true);
                    seterrorTextMathmaticsObtained("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    seterrorMathmaticsObtained(true);
                    seterrorTextMathmaticsObtained("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    seterrorMathmaticsObtained(true);
                //    seterrorTextMathmaticsObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                seterrorMathmaticsObtained(false);
                seterrorTextMathmaticsObtained("");
                return false;
            }
        }
    }
    function ValidateMathematicsOutof(MathematicsOutofMarks) {
        if (MathematicsOutofMarks == null || Number(MathematicsOutofMarks) == 0) {
            setErrorMathmaticsOutof(true);
            setErrorTextMathmaticsOutof("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(MathematicsOutofMarks)) {
                setErrorMathmaticsOutof(true);
                setErrorTextMathmaticsOutof("Enter valid Out of marks");
                return true;
            }
            else {
                // let a = parseFloat(MathematicsOutofMarks);
                // //if (a > 100) {
                // //    setErrorMathmaticsOutof(true);
                // //    setErrorTextMathmaticsOutof("Enter Out of marks less than equal to 100");
                // //    return true;
                // //}
                //// seterrorMathmaticsObtained(false);
                //// seterrorTextMathmaticsObtained("");
                // setErrorMathmaticsOutof(false);
                // setErrorTextMathmaticsOutof("");
                // return false;

                setErrorMathmaticsOutof(false);
                setErrorTextMathmaticsOutof("");

                let a = parseFloat(mathmaticsObtained);
                let b = parseFloat(MathematicsOutofMarks);
                if (a > b) {
                    seterrorMathmaticsObtained(true);
                    seterrorTextMathmaticsObtained("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    seterrorMathmaticsObtained(false);
                    seterrorTextMathmaticsObtained("");
                    return false;
                }
            }
        }
    }

    function ValidateMathematicsOutof9th(MathematicsOutofMarks) {
        if (MathematicsOutofMarks == null || Number(MathematicsOutofMarks) == 0) {
            setErrorMathmaticsOutof9th(true);
            setErrorTextMathmaticsOutof9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(MathematicsOutofMarks)) {
                setErrorMathmaticsOutof9th(true);
                setErrorTextMathmaticsOutof9th("Enter valid Out of marks");
                return true;
            }
            else {
                // let a = parseFloat(MathematicsOutofMarks);
                // //if (a > 100) {
                // //    setErrorMathmaticsOutof(true);
                // //    setErrorTextMathmaticsOutof("Enter Out of marks less than equal to 100");
                // //    return true;
                // //}
                //// seterrorMathmaticsObtained(false);
                //// seterrorTextMathmaticsObtained("");
                // setErrorMathmaticsOutof(false);
                // setErrorTextMathmaticsOutof("");
                // return false;

                setErrorMathmaticsOutof9th(false);
                setErrorTextMathmaticsOutof9th("");

                let a = parseFloat(mathmaticsObtained9th);
                let b = parseFloat(MathematicsOutofMarks);
                if (a > b) {
                    seterrorMathmaticsObtained9th(true);
                    seterrorTextMathmaticsObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    seterrorMathmaticsObtained9th(false);
                    seterrorTextMathmaticsObtained9th("");
                    return false;
                }
            }
        }
    }

    function ValidateScienceObtained(ScienceObtainedMarks) {
        if (ScienceObtainedMarks == null || Number(ScienceObtainedMarks) == 0) {
            setErrorScienceObtained(true);
            setErrorTextScienceObtained("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(ScienceObtainedMarks)) {
                setErrorScienceObtained(true);
                setErrorTextScienceObtained("Enter valid Obtained marks");

                setErrorSciencePerofMarks(true);
                setErrorTextSciencePerofMarks("");
                return true;
            }
            else {
                let a = parseFloat(ScienceObtainedMarks);
                let b = parseFloat(scienceOutof);
                if (a <= 0) {
                    setErrorScienceObtained(true);
                    setErrorTextScienceObtained("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorScienceObtained(true);
                    setErrorTextScienceObtained("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    setErrorScienceObtained(true);
                //    setErrorTextScienceObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                setErrorScienceObtained(false);
                setErrorTextScienceObtained("");
                return false;
            }
        }
    }
    function ValidateScienceObtained9th(ScienceObtainedMarks) {
        if (ScienceObtainedMarks == null || Number(ScienceObtainedMarks) == 0) {
            setErrorScienceObtained9th(true);
            setErrorTextScienceObtained9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(ScienceObtainedMarks)) {
                setErrorScienceObtained9th(true);
                setErrorTextScienceObtained9th("Enter valid Obtained marks");

                setErrorSciencePerofMarks9th(true);
                setErrorTextSciencePerofMarks9th("");
                return true;
            }
            else {
                let a = parseFloat(ScienceObtainedMarks);
                let b = parseFloat(scienceOutof9th);
                if (a <= 0) {
                    setErrorScienceObtained9th(true);
                    setErrorTextScienceObtained9th("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorScienceObtained9th(true);
                    setErrorTextScienceObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    setErrorScienceObtained(true);
                //    setErrorTextScienceObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                setErrorScienceObtained9th(false);
                setErrorTextScienceObtained9th("");
                return false;
            }
        }
    }

    function ValidateScienceOutOf(ScienceOutOfMarks) {
        if (ScienceOutOfMarks == null || Number(ScienceOutOfMarks) == 0) {
            setErrorScienceOutof(true);
            setErrorTextScienceOutof("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(ScienceOutOfMarks)) {
                setErrorScienceOutof(true);
                setErrorTextScienceOutof("Enter valid Out of marks");
                return true;
            }
            else {
                //let a = parseFloat(ScienceOutOfMarks);
                ////if (a > 100) {
                ////    setErrorScienceOutof(true);
                ////    setErrorTextScienceOutof("Enter Out of marks less than equal to 100");
                ////    return true;
                ////}
                ////setErrorScienceObtained(false);
                ////setErrorTextScienceObtained("");
                //setErrorScienceOutof(false);
                //setErrorTextScienceOutof("");
                //return false;

                setErrorScienceOutof(false);
                setErrorTextScienceOutof("");

                let a = parseFloat(scienceObtained);
                let b = parseFloat(ScienceOutOfMarks);
                if (a > b) {
                    setErrorScienceObtained(true);
                    setErrorTextScienceObtained("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorScienceObtained(false);
                    setErrorTextScienceObtained("");
                    return false;
                }
            }
        }
    }
    function ValidateScienceOutOf9th(ScienceOutOfMarks) {
        if (ScienceOutOfMarks == null || Number(ScienceOutOfMarks) == 0) {
            setErrorScienceOutof9th(true);
            setErrorTextScienceOutof9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(ScienceOutOfMarks)) {
                setErrorScienceOutof9th(true);
                setErrorTextScienceOutof9th("Enter valid Out of marks");
                return true;
            }
            else {
                //let a = parseFloat(ScienceOutOfMarks);
                ////if (a > 100) {
                ////    setErrorScienceOutof(true);
                ////    setErrorTextScienceOutof("Enter Out of marks less than equal to 100");
                ////    return true;
                ////}
                ////setErrorScienceObtained(false);
                ////setErrorTextScienceObtained("");
                //setErrorScienceOutof(false);
                //setErrorTextScienceOutof("");
                //return false;

                setErrorScienceOutof9th(false);
                setErrorTextScienceOutof9th("");

                let a = parseFloat(scienceObtained9th);
                let b = parseFloat(ScienceOutOfMarks);
                if (a > b) {
                    setErrorScienceObtained9th(true);
                    setErrorTextScienceObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorScienceObtained9th(false);
                    setErrorTextScienceObtained9th("");
                    return false;
                }
            }
        }
    }

    function ValidateEnglishObtained(EnglishObtainedMarks) {
        if (EnglishObtainedMarks == null || Number(EnglishObtainedMarks) == 0) {
            setErrorEnglishObtained(true);
            setErrorTextEnglishObtained("Mandatory field");
            seterrorEnglishPerofMarks(false);
            seterrorTextEnglishPerofMarks("");
            return true;
        }
        else {
            if (!IsNumeric(EnglishObtainedMarks)) {
                setErrorEnglishObtained(true);
                setErrorTextEnglishObtained("Enter valid Obtained marks");

                seterrorEnglishPerofMarks(true);
                seterrorTextEnglishPerofMarks("");
                return true;
            }
            else {
                let a = parseFloat(EnglishObtainedMarks);
                let b = parseFloat(englishOutof);
                if (a <= 0) {
                    setErrorEnglishObtained(true);
                    setErrorTextEnglishObtained("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorEnglishObtained(true);
                    setErrorTextEnglishObtained("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    setErrorEnglishObtained(true);
                //    setErrorTextEnglishObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                setErrorEnglishObtained(false);
                setErrorTextEnglishObtained("");
                return false;
            }
        }
    }
    function ValidateEnglishObtained9th(EnglishObtainedMarks) {
        if (EnglishObtainedMarks == null || Number(EnglishObtainedMarks) == 0) {
            setErrorEnglishObtained9th(true);
            setErrorTextEnglishObtained9th("Mandatory field");
            seterrorEnglishPerofMarks9th(false);
            seterrorTextEnglishPerofMarks9th("");
            return true;
        }
        else {
            if (!IsNumeric(EnglishObtainedMarks)) {
                setErrorEnglishObtained9th(true);
                setErrorTextEnglishObtained9th("Enter valid Obtained marks");

                seterrorEnglishPerofMarks9th(true);
                seterrorTextEnglishPerofMarks9th("");
                return true;
            }
            else {
                let a = parseFloat(EnglishObtainedMarks);
                let b = parseFloat(englishOutof);
                if (a <= 0) {
                    setErrorEnglishObtained9th(true);
                    setErrorTextEnglishObtained9th("Marks can't be less than 0");
                    return true;
                }
                if (a > b) {
                    setErrorEnglishObtained9th(true);
                    setErrorTextEnglishObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                //if (a > 100) {
                //    setErrorEnglishObtained(true);
                //    setErrorTextEnglishObtained("Marks can't be greater than out of marks");
                //    return true;
                //}
                setErrorEnglishObtained9th(false);
                setErrorTextEnglishObtained9th("");
                return false;
            }
        }
    }

    function ValidateEnglishOutOf(EnglishOutOfMarks) {
        if (EnglishOutOfMarks == null || Number(EnglishOutOfMarks) == 0) {
            setErrorEnglishOutof(true);
            setErrorTextEnglishOutof("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(EnglishOutOfMarks)) {
                setErrorEnglishOutof(true);
                setErrorTextEnglishOutof("Enter valid Out of marks");
                return true;
            }
            else {
                setErrorEnglishOutof(false);
                setErrorTextEnglishOutof("");

                let a = parseFloat(englishObtained);
                let b = parseFloat(EnglishOutOfMarks);
                if (a > b) {
                    setErrorEnglishObtained(true);
                    setErrorTextEnglishObtained("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorEnglishObtained(false);
                    setErrorTextEnglishObtained("");
                    return false;
                }
            }
        }
    }
    function ValidateEnglishOutOf9th(EnglishOutOfMarks) {
        if (EnglishOutOfMarks == null || Number(EnglishOutOfMarks) == 0) {
            setErrorEnglishOutof9th(true);
            setErrorTextEnglishOutof9th("Mandatory field");
            return true;
        }
        else {
            if (!IsNumeric(EnglishOutOfMarks)) {
                setErrorEnglishOutof9th(true);
                setErrorTextEnglishOutof9th("Enter valid Out of marks");
                return true;
            }
            else {
                setErrorEnglishOutof9th(false);
                setErrorTextEnglishOutof9th("");

                let a = parseFloat(englishObtained9th);
                let b = parseFloat(EnglishOutOfMarks);
                if (a > b) {
                    setErrorEnglishObtained9th(true);
                    setErrorTextEnglishObtained9th("Marks can't be greater than out of marks");
                    return true;
                }
                else {
                    setErrorEnglishObtained9th(false);
                    setErrorTextEnglishObtained9th("");
                    return false;
                }
            }
        }
    }
    function ValidateCommonDetails(data) {
        var a = false, b = false, c = false, d = false, e = false, f = false, g = false, h = false, i = false, j = false, k = false, l = false, m = false;//, n = false;
        var a1 = false, b1 = false, c1 = false, d1 = false, e1 = false, f1 = false, g1 = false, h1 = false, i1 = false;//, j1 = false, k1 = false, l1 = false, m1 = false, n1 = false;
        a = ValidateFirstName(data.FirstName);
        b = ValidateLastName(data.LastName);
        c = ValidateEmail(data.Email);
        d = ValidateContactNo(data.ContactNumber);
        e = ValidateGender(data.GenderId);
        f = ValidateBirthYear(data.BirthYear);
        g = ValidatePresentAddress(data.PresentAddress);
        l = ValidateParentContactNo(data.MContactNo);
        //m = ValidatePerOfTotalMarks(data.PercentageOfTotalMarks);
        //n = ValidateTotalperofMarks(data.TotalPercentage);
        if (imageProfileId == 0 || imageData == null) {
            i1 = true;
            setErrorProfilePhoto(true);
            setErrorTextProfilePhoto(true);
        }
        if (a || b || c || d || e || f || g || l || i1) {
            return false;
        }
        else {
            return true;
        }
    }

    function ValidateFormFields(data) {
        var a = false, b = false, c = false, d = false, e = false, f = false, g = false, h = false, i = false, j = false, k = false, l = false, m = false;//, n = false;
        var a1 = false, b1 = false, c1 = false, d1 = false, e1 = false, f1 = false, g1 = false, h1 = false, i1 = false;//, j1 = false, k1 = false, l1 = false, m1 = false, n1 = false;
        var a2 = false, b2 = false, c2 = false, d2 = false, e2 = false, f2 = false, g2 = false, h2 = false, i2 = false, j2 = false, k2 = false;

        a = ValidateFirstName(data.FirstName);
        b = ValidateLastName(data.LastName);
        c = ValidateEmail(data.Email);
        d = ValidateContactNo(data.ContactNumber);
        e = ValidateGender(data.GenderId);
        f = ValidateBirthYear(data.BirthYear);
        g = ValidatePresentAddress(data.PresentAddress);
        h = ValidateQualification(data.QualificationId);
        i = ValidateYearOfPassing(data.YearOfPassing);
        j = ValidatePerOfTotalMarks(data.PercentageOfTotalMarks);
        k = ValidateNameofBoard(data.NameOfBoard);
        l = ValidateParentContactNo(data.MContactNo);
        //m = ValidatePerOfTotalMarks(data.PercentageOfTotalMarks);
        //n = ValidateTotalperofMarks(data.TotalPercentage);

        a1 = ValidateEnglishObtained(data.EnglishObtainedMarks);
        b1 = ValidateEnglishOutOf(data.EnglishOutOfMarks);
        c1 = ValidateMathematicsObtained(data.MathematicsObtainedMarks);
        d1 = ValidateMathematicsOutof(data.MathematicsOutofMarks);
        g1 = ValidateScienceObtained(data.ScienceObtainedMarks);
        h1 = ValidateScienceOutOf(data.ScienceOutOfMarks);
        e1 = ValidateTotalObtained(data.TotalObtainedMarks);
        f1 = ValidateTotalOutOf(data.TotalOutOfMarks);

        a2 = ValidateEnglishObtained9th(data.EnglishObtainedMarks9th);
        b2 = ValidateEnglishOutOf9th(data.EnglishOutOfMarks9th);
        c2 = ValidateMathematicsObtained9th(data.MathematicsObtainedMarks9th);
        d2 = ValidateMathematicsOutof9th(data.MathematicsOutofMarks9th);
        g2 = ValidateScienceObtained9th(data.ScienceObtainedMarks9th);
        h2 = ValidateScienceOutOf9th(data.ScienceOutOfMarks9th);
        e2 = ValidateTotalObtained9th(data.TotalObtainedMarks9th);
        f2 = ValidateTotalOutOf9th(data.TotalOutOfMarks9th);
        i2 = ValidateYearOfPassing9th(data.YearOfPassing9th);
        j2 = ValidatePerOfTotalMarks9th(data.PercentageOfTotalMarks9th);
        k2 = ValidateNameofBoard9th(data.NameOfBoard9th);

        if (imageProfileId == 0 || imageData == null) {
            i1 = true;
            setErrorProfilePhoto(true);
            setErrorTextProfilePhoto(true);
        }
        if (a || b || c || d || e || f || g || h || i || j || k || l || m || a1 || b1 || c1 || d1 || e1 || f1 || g1 || h1 ||
            a2 || b2 || c2 || d2 || e2 || f2 || g2 || h2 || i2 || j2 || k2 || i1) {
            return false;
        }
        else {
            return true;
        }
    }
    const SaveCandidate = async (candidateData) => {

        const token = siemensToken;
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            },
            body: candidateData
        }
        //await fetch('Student/RegisterCandidate/', options)
        const res = await fetch('Student/RegisterCandidate/', options).then(response => response.json());
        console.log('res.data', res);
        return res;
        //console.log('SystemInfeed Output Details', res.data);
    }
    async function getStudentDetails() {
        setOpenLoader(true);
        const token = siemensToken;
        const emailID = userDetails?.email;

        await fetch("Student/GetStudentDetails/" + emailID, {
            headers: {
                SiemensToken: siemensToken,
                UserEmail: emailID
            }
        })
            .then((response) => response.json())
            .then((data) => {
                //setIsLoader(false);
                //setcandidateData(data);
                setStatesStudent(data?.result[0]);
                console.log("data:", data?.result[0]);
                setOpenLoader(false);
            })
            .catch((error) => {
                console.log("Error:", error);
                setOpenLoader(false);
            });
    }



    async function RegisterCandidate(candidateData) {
        const token = siemensToken;
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            },
            body: candidateData
        }
        await fetch('Student/RegisterCandidate/', options)
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.result) {
                    setOpenLoader(false);
                    setOpen(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlert("You have successfully submitted your admission form, thank you.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Success");
                    setButtonTextSubmit("Submit");
                    setStudentId(data?.result.studentId);
                }
                else {
                    setOpenLoader(false);
                    setOpen(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlert("Registration failed.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Alert");
                    //alert("Candidate registration failed.");
                }
            })
            .catch(error => console.log("Error:", error));
        //    else {
        //        const token = props.token;
        //        const options = {
        //            method: 'put',
        //            headers: {
        //                'Accept': 'application/json, text/plain, */*',
        //                'Content-Type': 'application/json',
        //                'Authorization': 'Bearer ' + token
        //            },
        //            body: candidateData
        //        }
        //        await fetch('Student/SubmitCandidate/', options)
        //            .then(response => response.json())
        //            .then(data => {
        //                if (data.response) {
        //                    setStates(data);
        //                    setOpen(true);
        //                    setOpenAlert(data.responseMsg);
        //                    setClassName("bg-light-green clr-white");
        //                    setOpenType("Success");
        //                    //alert("Candidate data has been updated successfully.");
        //                    //window.location.href = '/CandidateData';
        //                }
        //                else {
        //                    setOpen(true);
        //                    setOpenAlert(data.responseMsg);
        //                    setClassName("bg-light-green clr-white");
        //                    setOpenType("Alert");
        //                    //alert("Candidate data update failed.");
        //                }
        //            })
        //            .catch(error => console.log("Error:", error));
        //    }
    }

    async function DraftRegisterCandidate(candidateData) {
        const token = siemensToken;
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            },
            body: candidateData
        }
        await fetch('Student/RegisterCandidate/', options)
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.result) {
                    setOpenLoader(false);
                    setOpen(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlert("You have successfully saved your form.Kindly enter your marks for 10th grade as soon as the results are declared and then only submit the form");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Success");
                    setButtonTextSubmit("Submit");
                    setStudentId(data?.result.studentId);
                }
                else {
                    setOpenLoader(false);
                    setOpen(true);
                    //setOpenAlert(data.responseMsg);
                    setOpenAlert("Registration failed.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Alert");
                    //alert("Candidate registration failed.");
                }
            })
            .catch(error => console.log("Error:", error));
    }


    async function UpdateCandidate(candidateData) {


        const token = siemensToken;
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            },
            body: candidateData
        }
        await fetch('Student/SubmitCandidate/', options)
            .then(response => response.json())
            .then(data => {
                if (data.result) {
                    //setStates(data);
                    setOpenLoader(false);
                    setOpen(true);
                    setOpenAlert("You have successfully submitted your admission form, thank you.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Success");
                    //alert("Candidate data has been updated successfully.");
                    //window.location.href = '/CandidateData';
                }
                else {
                    setOpenLoader(false);
                    setOpen(true);
                    setOpenAlert("Registration failed.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Alert");
                    //alert("Candidate data update failed.");
                }
            })
            .catch(error => console.log("Error:", error));

    }

    async function DraftUpdateCandidate(candidateData) {


        const token = siemensToken;
        const options = {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                SiemensToken: siemensToken,
                UserEmail: userDetails?.email
            },
            body: candidateData
        }
        await fetch('Student/SubmitCandidate/', options)
            .then(response => response.json())
            .then(data => {
                if (data.result) {
                    //setStates(data);
                    setOpenLoader(false);
                    setOpen(true);
                    setOpenAlert("You have successfully saved your form. Kindly enter your marks for 10th grade as soon as the results are declared and then only submit the form");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Success");
                    //alert("Candidate data has been updated successfully.");
                    //window.location.href = '/CandidateData';
                }
                else {
                    setOpenLoader(false);
                    setOpen(true);
                    setOpenAlert("Registration failed.");
                    setClassName("bg-light-green clr-white");
                    setOpenType("Alert");
                    //alert("Candidate data update failed.");
                }
            })
            .catch(error => console.log("Error:", error));

    }


    useEffect(() => {
        setFormHeaderText1("Siemens Technical Academy India ");
        setFormHeaderText2("Student Admission Form");
        window.scrollTo(0, 0);
        setOpenLoader(true);
        getStudentDetails();
        getGenter();
        getQualification();
        getTrade();
        if (siemensToken) {
            //getGenter();
            //getQualification();
            //getTrade();
            //if (encryptedId != undefined && encryptedId != "" && encryptedId != null) {
            //GetCandidateDetailsById(encryptedId);
            //}
            //else {
            setOpenLoader(false);
            //}
        }
        else {
            setOpenLoader(false);
        }
    }, [siemensToken]);
    //}, [encryptedId, props.token]);

    function clearStates() {
        setFirstName('');
        setMiddleName('');
        setLastName('');
        setBirthYear('');
        setGenter('');
        setContactNumber('');
        setfgFirstName('');
        setfgMiddleName('');
        setfgLastName('');
        setmFirstName('');
        setmMiddleName('');
        setmLastName('');
        //setfgContactNumber('');
        setmContactNumber('');
        setPresentAddress('');
        //setQualificationDet('');
        setYearofPassing('');
        setPercentage('');
        setNameofBoard('');
        setEnglishObtained('');
        setenglishOutof('');
        setenglishperofMarks('');
        setMathmaticsObtained('');
        setMathmaticsOutof('');
        setMathmaticsperofMarks('');
        setScienceObtained('');
        setScienceOutof('');
        setScienceperofMarks('');
        setTotalObtained('');
        setTotalOutof('');
        setTotalperofMarks('');
        //9th details
        setYearofPassing9th('');
        setPercentage9th('');
        setNameofBoard9th('');
        setEnglishObtained9th('');
        setenglishOutof9th('');
        setenglishperofMarks9th('');
        setMathmaticsObtained9th('');
        setMathmaticsOutof9th('');
        setMathmaticsperofMarks9th('');
        setScienceObtained9th('');
        setScienceOutof9th('');
        setScienceperofMarks9th('');
        setTotalObtained9th('');
        setTotalOutof9th('');
        setTotalperofMarks9th('');
        // setTradePrefered('');

        setErrorTextFirstName('');

        setErrorTextLastName('');
        setErrorTextBirthYear('');
        setErrorTextGender('');
        setErrorTextContactNumber('');
        setErrorTextfgFirstName('');
        setErrorTextmFirstName('');

        setErrorTextmLastName('');
        setErrorTextmContactNumber('');

        setErrorTextPresentAddress('');
        setErrorTextQualification('');
        setErrorTextYearofPassing('');
        setErrorTextPercentage('');
        setErrorTextNameofboard('');
        setErrorTextEnglishObtained('');
        setErrorTextEnglishOutof('');
        seterrorTextEnglishPerofMarks('');
        seterrorTextMathmaticsObtained('');
        setErrorTextMathmaticsOutof('');
        setErrorMathmaticsPerofMarks('');
        setErrorTextScienceObtained('');
        setErrorTextScienceOutof('');
        setErrorTextSciencePerofMarks('');
        setErrorTextTotalObtained('');
        setErrorTextTotalOutof('');
        setErrorTextTotalPerofMarks('');

        setErrorTextYearofPassing9th('');
        setErrorTextPercentage9th('');
        setErrorTextNameofboard9th('');
        setErrorTextEnglishObtained9th('');
        setErrorTextEnglishOutof9th('');
        seterrorTextEnglishPerofMarks9th('');
        seterrorTextMathmaticsObtained9th('');
        setErrorTextMathmaticsOutof9th('');
        setErrorMathmaticsPerofMarks9th('');
        setErrorTextScienceObtained9th('');
        setErrorTextScienceOutof9th('');
        setErrorTextSciencePerofMarks9th('');
        setErrorTextTotalObtained9th('');
        setErrorTextTotalOutof9th('');
        setErrorTextTotalPerofMarks9th('');

        setErrorfgFirstName(false);
        setErrorfgLastName(false);
        setErrorTextfgLastName('');
        setErrormFirstName('');
        setErrormLastName('');
    }

    function setStates(data) {
        setStudentId(data.StudentId);
        setFirstName(data.FirstName);
        setMiddleName(data.MiddleName);
        setLastName(data.LastName);
        setBirthYear(data.BirthYear);
        setGenter(data.GenderId);
        setContactNumber(data.ContactNumber);
        setEmail(data.Email);
        setfgFirstName(data.FGFirstName);
        setfgMiddleName(data.FGMiddleName);
        setfgLastName(data.FGLastName);
        setmFirstName(data.MFirstName);
        setmMiddleName(data.MMiddleName);
        setmLastName(data.MLastName);
        setfgContactNumber(data.FGContactNo);
        setmContactNumber(data.MContactNo);
        setPresentAddress(data.PresentAddress);
        setQualificationDet(data.QualificationId);
        setYearofPassing(data.YearOfPassing);
        setPercentage(data.PercentageOfTotalMarks);
        setNameofBoard(data.NameOfBoard);
        setEnglishObtained(data.EnglishObtainedMarks);
        setenglishOutof(data.EnglishOutOfMarks);
        setenglishperofMarks(data.EnglishPercentage);
        setMathmaticsObtained(data.mathmaticsObtained);
        setMathmaticsOutof(data.MathematicsOutofMarks);
        setMathmaticsperofMarks(data.MathematicsPercentage);
        setScienceObtained(data.ScienceObtainedMarks);
        setScienceOutof(data.ScienceOutOfMarks);
        setScienceperofMarks(data.ScienceOutOfMarks);
        setTotalObtained(data.TotalObtainedMarks);
        setTotalOutof(data.TotalOutOfMarks);
        setTotalperofMarks(data.TotalPercentage);
        setTradePrefered(data.TradeId);
    }

    function setStatesStudent(data) {
        setStudentId(data.studentId);
        setFirstName(data.firstName);
        setMiddleName(data.middleName);
        setLastName(data.lastName);
        setBirthYear(data.birthYear);
        setGenter(data.genderId);
        setContactNumber(data.contactNumber);
        setEmail(data.email);
        setfgFirstName(data.fgfirstName);
        setfgMiddleName(data.fgmiddleName);
        setfgLastName(data.fglastName);
        setmFirstName(data.mfirstName);
        setmMiddleName(data.mmiddleName);
        setmLastName(data.mlastName);
        setfgContactNumber(data.fgcontactNo);
        setmContactNumber(data.mcontactNo);
        setPresentAddress(data.presentAddress);
        if (data.studentEducationalDetails != null) {
            if (data.studentEducationalDetails[0].qualificationId == 1) {
                //setQualificationDet(data.qualificationId);
                setQualificationDet(data.studentEducationalDetails[0].qualificationId);
                setYearofPassing(data.studentEducationalDetails[0].yearOfPassing);
                setPercentage(data.studentEducationalDetails[0].percentageOfTotalMarks);
                setNameofBoard(data.studentEducationalDetails[0].nameOfBoard);
                setEnglishObtained(data.studentEducationalDetails[0].englishObtainedMarks);
                setenglishOutof(data.studentEducationalDetails[0].englishOutOfMarks);
                setenglishperofMarks(data.studentEducationalDetails[0].englishPercentage);
                setMathmaticsObtained(data.studentEducationalDetails[0].mathematicsObtainedMarks);
                setMathmaticsOutof(data.studentEducationalDetails[0].mathematicsOutofMarks);
                setMathmaticsperofMarks(data.studentEducationalDetails[0].mathematicsPercentage);
                setScienceObtained(data.studentEducationalDetails[0].scienceObtainedMarks);
                setScienceOutof(data.studentEducationalDetails[0].scienceOutOfMarks);
                setScienceperofMarks(data.studentEducationalDetails[0].scienceOutOfMarks);
                setTotalObtained(data.studentEducationalDetails[0].totalObtainedMarks);
                setTotalOutof(data.studentEducationalDetails[0].totalOutOfMarks);
                setTotalperofMarks(data.studentEducationalDetails[0].totalPercentage);
                setTradePrefered(data.studentEducationalDetails[0].tradeId);
            }
            if (data.studentEducationalDetails[1].qualificationId == 2) {
                setYearofPassing9th(data.studentEducationalDetails[1].yearOfPassing);
                setPercentage9th(data.studentEducationalDetails[1].percentageOfTotalMarks);
                setNameofBoard9th(data.studentEducationalDetails[1].nameOfBoard);
                setEnglishObtained9th(data.studentEducationalDetails[1].englishObtainedMarks);
                setenglishOutof9th(data.studentEducationalDetails[1].englishOutOfMarks);
                setenglishperofMarks9th(data.studentEducationalDetails[1].englishPercentage);
                setMathmaticsObtained9th(data.studentEducationalDetails[1].mathematicsObtainedMarks);
                setMathmaticsOutof9th(data.studentEducationalDetails[1].mathematicsOutofMarks);
                setMathmaticsperofMarks9th(data.studentEducationalDetails[1].mathematicsPercentage);
                setScienceObtained9th(data.studentEducationalDetails[1].scienceObtainedMarks);
                setScienceOutof9th(data.studentEducationalDetails[1].scienceOutOfMarks);
                setScienceperofMarks9th(data.studentEducationalDetails[1].scienceOutOfMarks);
                setTotalObtained9th(data.studentEducationalDetails[1].totalObtainedMarks);
                setTotalOutof9th(data.studentEducationalDetails[1].totalOutOfMarks);
                setTotalperofMarks9th(data.studentEducationalDetails[1].totalPercentage);
                setTradePrefered(data.studentEducationalDetails[1].tradeId);
            }
        }
        if (data.studentProfile != null) {
            for (var i = 0; i < data.studentProfile.length; i++) {
                if (data.studentProfile[i].isActive == 1) {
                    setImageData(data.studentProfile[i].imageContent);
                    setImageFile(null);
                    setImageProfileId(data.studentProfile[i].profileId);
                }


            }

        }

    }

    return (
        <ThemeProvider theme={theme}>
            <div className="master-layout-block">
                <Box className="Box-padding text-center">
                    <h3 className="clr-dark-blue d-flex jc-center">{formHeaderText1}</h3>
                </Box>
                <Box>
                    <h3 className="clr-dark-blue d-flex jc-center">{formHeaderText2}</h3>
                </Box>
                <form className="d-flex jc-center">
                    <Grid container item xs={12} spacing={1} className="d-flex fd-column box-shadow px-2 mb-2 bdr-radius ">
                        <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                            <Grid container spacing={1} item xs={12} sm={3} className="d-flex Width-100">
                                <Grid item xs={12} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Candidate Details</InputLabel>
                                </Grid>
                                <Grid item xs={12} className="d-flex Width-100">
                                    {
                                        (imageData != null && imageData.length > 0)
                                            ?
                                            <React.Fragment>
                                                <img src={`data:image/*;base64,${imageData}`} alt="Candidate Image" height="140" width="140" /><br />
                                                {
                                                    <React.Fragment>
                                                        <Tooltip title="Delete Image" placement="top">
                                                            <span>
                                                                <Button onClick={deleteImageHandler}>
                                                                    <span className="mr-2">
                                                                        <RemoveCircleOutlineOutlinedIcon color="secondary" style={{ fontSize: 15 }} />
                                                                    </span>
                                                                </Button>
                                                            </span>
                                                        </Tooltip>
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                            :
                                            <React.Fragment></React.Fragment>
                                    }
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} item xs={12} sm={9} className="d-flex Width-100">
                                <Grid item xs={12} sm={4} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="firstName"
                                        label="First Name"
                                        variant="filled"
                                        fullWidth
                                        name="First Name"
                                        value={firstName}
                                        onChange={changeEventFirstName}
                                        required
                                        error={errorFirstName}
                                        helperText={errorTextFirstName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="middleName"
                                        label="Middle Name"
                                        variant="filled"
                                        fullWidth
                                        name="Middle Name"
                                        value={middleName}
                                        onChange={changeEventMiddleName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="lastName"
                                        fullWidth
                                        label="Last Name"
                                        variant="filled"
                                        name="Last Name"
                                        value={lastName}
                                        onChange={changeEventLastName}
                                        required
                                        error={errorLastName}
                                        helperText={errorTextLastName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="contactNumber"
                                        label="Contact Number"
                                        variant="filled"
                                        fullWidth
                                        name="Contact Number"
                                        value={ContactNumber}
                                        onChange={changeEventContactNumber}
                                        required
                                        error={errorContactNumber}
                                        helperText={errorTextContactNumber}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="birthyear"
                                        label="Year of Birth"
                                        variant="filled"
                                        fullWidth
                                        name="Year of Birth"
                                        value={birthYear}
                                        onChange={changeEventBirthYear}
                                        required
                                        error={errorBirthYear}
                                        helperText={errorTextBirthYear}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4} className="d-flex jc-center mt-1 Width-100">
                                    <FormControl variant="filled" className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                        <Select className="lightInputFields"
                                            labelId="demo-simple-select-label"
                                            id="ddlGenter"
                                            value={genter}
                                            required
                                            error={errorGender}
                                            helperText={errorTextGender}
                                            onChange={changeEventGenter}
                                        >
                                            {
                                                itemsGenter.map(item => (
                                                    <MenuItem
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.gender}
                                                    </MenuItem>)
                                                )}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={5} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="email"
                                        label="Email"
                                        variant="filled"
                                        fullWidth
                                        name="Email"
                                        value={email}
                                        onChange={changeEventEmail}
                                        required
                                        error={errorEmail}
                                        helperText={errorTextEmail}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} className="d-flex jc-center mt-1 Width-100">
                                    <label className="InputLable">
                                        <Input
                                            className="InputFile"
                                            type="file"
                                            fullWidth
                                            onChange={changeFileHandler}
                                            required
                                            //key={inputFileValue}
                                            disabled={imageData != null && imageData.length > 0 ? true : false}
                                            error={errorProfilePhoto}
                                            helperText={errorTextProfilePhoto}
                                        />
                                        <span>
                                            Please upload latest photo (maximum size 2 MB)</span>
                                    </label>
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">
                                    <Button
                                        variant="contained"
                                        className="ns-btn-custom mt-0bt2 mr-1"
                                        onClick={uploadHandler}
                                        disabled={imageData != null && imageData.length > 0 ? true : false}
                                    > Upload Photo
                                    </Button>
                                </Grid>


                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={4} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Family Details</InputLabel>
                                </Grid>
                                <Grid item xs={12} sm={8} className="d-flex Width-100">
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Father/Guardian Name</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="fgfirstName"
                                        label="First Name"
                                        variant="filled"
                                        fullWidth
                                        name="First Name"
                                        value={fgfirstName}
                                        onChange={changeEventfgFirstName}
                                        error={errorfgFirstName}
                                        helperText={errorTextfgFirstName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="fgmiddleName"
                                        label="Middle Name"
                                        variant="filled"
                                        fullWidth
                                        name="Middle Name"
                                        value={fgmiddleName}
                                        onChange={changeEventfgMiddleName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="lastName"
                                        fullWidth
                                        label="Last Name"
                                        variant="filled"
                                        name="Last Name"
                                        value={fglastName}
                                        onChange={changeEventfgLastName}
                                        error={errorfgLastName}
                                        helperText={errorTextfgLastName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Mother Name</InputLabel>
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="mfirstName"
                                        label="First Name"
                                        variant="filled"
                                        fullWidth
                                        name="First Name"
                                        value={mfirstName}
                                        onChange={changeEventmFirstName}
                                        error={errormFirstName}
                                        helperText={errorTextmFirstName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex  Width-100">
                                    <TextField className="mt-1 lightInputFields"
                                        id="mmiddleName"
                                        label="Middle Name"
                                        variant="filled"
                                        fullWidth
                                        name="Middle Name"
                                        value={mmiddleName}
                                        onChange={changeEventmMiddleName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="mlastName"
                                        fullWidth
                                        label="Last Name"
                                        variant="filled"
                                        name="Last Name"
                                        value={mlastName}
                                        onChange={changeEventmLastName}
                                        error={errormLastName}
                                        helperText={errorTextmLastName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex jc-center Width-100"></Grid>
                                <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">
                                    <FormControl variant="filled" className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-label">Alternate Contact Person Number</InputLabel>
                                        <Select className="lightInputFields"
                                            labelId="demo-simple-select-label"
                                            id="ddlfgcontact"
                                            value={fgContactNumber}
                                            onChange={changeEventfgContactNumber}
                                            required
                                        >
                                            <MenuItem key="1" value="1">Father</MenuItem>
                                            <MenuItem key="2" value="2">Guardian</MenuItem>
                                            <MenuItem key="3" value="3">Mother</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="mcontactNumber"
                                        label="Contact Number"
                                        variant="filled"
                                        fullWidth
                                        name="Contact Number"
                                        value={mContactNumber}
                                        required
                                        onChange={changeEventmContactNumber}
                                        error={errormContactNumber}
                                        helperText={errorTextmContactNumber}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="presentAddress"
                                        label="Present Address"
                                        variant="filled"
                                        fullWidth
                                        name="Present Address"
                                        value={presentAddress}
                                        required
                                        onChange={changeEventPresentAddress}
                                        error={errorPresentAddress}
                                        helperText={errorTextPresentAddress}
                                    />
                                </Grid>

                                {/* <Grid item xs={12} sm={3} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields cst-textarea mt-1"
                                        id="presentAddress"
                                        //rowsMin={3}
                                        label="Present Address"
                                        value={presentAddress}
                                        required
                                        onChange={changeEventPresentAddress}
                                        error={errorPresentAddress}
                                        helperText={errorTextPresentAddress}
                                    />
                                </Grid>*/}
                            </Grid>
                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={12} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Educational Details</InputLabel>
                                </Grid>
                                {/*-----------------------9th Qualification Details Starts------------------------------*/}
                                <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">
                                    <FormControl variant="filled" className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-label"></InputLabel>
                                        <Select className="lightInputFields"
                                            labelId="demo-simple-select-label"
                                            id="ddlQualificationDet"
                                            value={qualificationDet9th}
                                            onChange={changeEventQualificationDet9th}
                                            error={errorQualification9th}
                                            required
                                            helperText={errorTextQualification9th}
                                        >
                                            {itemsQualification9th.map(item => (
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.qualification}
                                                </MenuItem>)
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="yearofpassing"
                                        label="Year of passing"
                                        variant="filled"
                                        fullWidth
                                        name="Year of passing"
                                        value={yearofPassing9th}
                                        onChange={changeEventyearofPassing9th}
                                        required
                                        error={erroryearofPassing9th}
                                        helperText={errorTextyearofPassing9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="percentageoftotalmarks"
                                        label="% of Total Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Total Marks"
                                        value={percentage9th}
                                        onChange={changeEventpercentage9th}
                                        required
                                        error={errorpercentage9th}
                                        helperText={errorTextpercentage9th}
                                        onBlur={blurEventpercentage9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex jc-center Width-100">
                                    <TextField className="lightInputFields mt-1"
                                        id="nameofboard"
                                        fullWidth
                                        label="Name of Board"
                                        variant="filled"
                                        name="Name of Board"
                                        value={nameofboard9th}
                                        onChange={changeEventNameofboard9th}
                                        required
                                        error={errorNameofboard9th}
                                        helperText={errorTextNameofboard9th}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={12} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Details of marks obtained</InputLabel>
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">English</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="english"
                                        label="English Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="English Obtained"
                                        value={englishObtained9th}
                                        onChange={changeEventEnglishObtained9th}
                                        error={errorEnglishObtained9th}
                                        helperText={errorTextEnglishObtained9th}
                                        required
                                        onBlur={blurEventEnglishObtained9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="english"
                                        label="English Out of"
                                        variant="filled"
                                        fullWidth
                                        name="English Out of"
                                        value={englishOutof9th}
                                        onChange={changeEventEnglishOutof9th}
                                        error={errorEnglishOutof9th}
                                        helperText={errorTextEnglishOutof9th}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField helper-text-disabled"
                                        id="englishper"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={englishperofMarks9th}
                                        onChange={changeEventEnglishPerofMarks9th}
                                        error={errorEnglishPerofMarks9th}
                                        helperText={errorTextEnglishPerofMarks9th}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Mathematics(Higher)</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="mathematics"
                                        label="Mathematics Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Mathematics Obtained"
                                        value={mathmaticsObtained9th}
                                        onChange={changeEventMathmaticsObtained9th}
                                        error={errorMathmaticsObtained9th}
                                        helperText={errorTextMathmaticsObtained9th}
                                        required
                                        onBlur={blurEventMathmaticsObtained9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="Mathematicsoutof"
                                        label="Mathematics Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Mathematics Out of"
                                        value={mathmaticsOutof9th}
                                        onChange={changeEventMathmaticsOutof9th}
                                        error={errorMathmaticsOutof9th}
                                        helperText={errorTextMathmaticsOutof9th}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="mathmaticspermarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={mathmaticsperofMarks9th}
                                        onChange={changeEventMathmaticsPerofMarks9th}
                                        error={errorMathmaticsPerofMarks9th}
                                        helperText={errorTextMathmaticsPerofMarks9th}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Science</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="science"
                                        label="Science Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Science Obtained"
                                        value={scienceObtained9th}
                                        onChange={changeEventScienceObtained9th}
                                        error={errorScienceObtained9th}
                                        helperText={errorTextScienceObtained9th}
                                        required
                                        onBlur={blurEventScienceObtained9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="scienceoutof"
                                        label="Science Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Science Out of"
                                        value={scienceOutof9th}
                                        onChange={changeEventScienceOutof9th}
                                        error={errorScienceOutof9th}
                                        helperText={errorTextScienceOutof9th}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="sciencepermarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={scienceperofMarks9th}
                                        onChange={changeEventSciencePerofMarks9th}
                                        error={errorSciencePerofMarks9th}
                                        helperText={errorTextSciencePerofMarks9th}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Total (All Subject)</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField" id="science"
                                        label="Total Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Total Obtained"
                                        value={totalObtained9th}
                                        onChange={changeEventTotalObtained9th}
                                        error={errorTotalObtained9th}
                                        helperText={errorTextTotalObtained9th}
                                        required
                                        onBlur={blurEventTotalObtained9th}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="totaloutof"
                                        label="Total Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Total Out of"
                                        value={totalOutof9th}
                                        onChange={changeEventTotalOutof9th}
                                        error={errorTotalOutof9th}
                                        helperText={errorTextTotalOutof9th}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="percentagemarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={totalperofMarks9th}
                                        onChange={changeEventPerofMarks9th}
                                        error={errorTotalPerofMarks9th}
                                        helperText={errorTextTotalPerofMarks9th}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            {/*<Grid container spacing={2} className="d-flex jc-space-around fd-row">*/}
                            {/*    <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100"></Grid>*/}
                            {/*    <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">*/}
                            {/*        <FormControl variant="filled" className={classes.formControl}>*/}
                            {/*            <InputLabel id="demo-simple-select-label">Trade prefered</InputLabel>*/}
                            {/*            <Select className="lightInputFields"*/}
                            {/*                labelId="demo-simple-select-label"*/}
                            {/*                id="ddlEmployeeType"*/}
                            {/*                value={tradePrefered}*/}
                            {/*                onChange={changeEventTradePrefered}*/}
                            {/*            >*/}
                            {/*                {itemsTradePrefered.map(item => (*/}
                            {/*                    <MenuItem*/}
                            {/*                        key={item.id}*/}
                            {/*                        value={item.id}*/}
                            {/*                    >*/}
                            {/*                        {item.trade}*/}
                            {/*                    </MenuItem>)*/}
                            {/*                )}*/}
                            {/*            </Select>*/}
                            {/*        </FormControl>*/}
                            {/*    </Grid>*/}
                            {/*    <Grid item xs={12} sm={6} className="d-flex jc-center mt-1 Width-100"></Grid>*/}
                            {/*    <Grid item xs={12} sm={12} className="privacyBtn">*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                            {/*-----------------------9th Qualification Details End------------------------------*/}


                            {/*-----------------------10th Qualification Details Starts------------------------------*/}

                            <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">
                                <FormControl variant="filled" className={classes.formControl}>
                                    <InputLabel id="demo-simple-select-label"></InputLabel>
                                    <Select className="lightInputFields"
                                        labelId="demo-simple-select-label"
                                        id="ddlQualificationDet"
                                        value={qualificationDet}
                                        onChange={changeEventQualificationDet}
                                        error={errorQualification}
                                        required
                                        helperText={errorTextQualification}
                                    >
                                        {itemsQualification.map(item => (
                                            <MenuItem
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.qualification}
                                            </MenuItem>)
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={3} className="d-flex Width-100">
                                <TextField className="lightInputFields mt-1"
                                    id="yearofpassing"
                                    label="Year of passing"
                                    variant="filled"
                                    fullWidth
                                    name="Year of passing"
                                    value={yearofPassing}
                                    onChange={changeEventyearofPassing}
                                    required
                                    error={erroryearofPassing}
                                    helperText={errorTextyearofPassing}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} className="d-flex Width-100">
                                <TextField className="lightInputFields mt-1"
                                    id="percentageoftotalmarks"
                                    label="% of Total Marks"
                                    variant="filled"
                                    fullWidth
                                    name="% of Total Marks"
                                    value={percentage}
                                    onChange={changeEventpercentage}
                                    required
                                    error={errorpercentage}
                                    helperText={errorTextpercentage}
                                    onBlur={blurEventpercentage}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} className="d-flex jc-center Width-100">
                                <TextField className="lightInputFields mt-1"
                                    id="nameofboard"
                                    fullWidth
                                    label="Name of Board"
                                    variant="filled"
                                    name="Name of Board"
                                    value={nameofboard}
                                    onChange={changeEventNameofboard}
                                    required
                                    error={errorNameofboard}
                                    helperText={errorTextNameofboard}
                                />
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={12} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Details of marks obtained</InputLabel>
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">English</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="english"
                                        label="English Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="English Obtained"
                                        value={englishObtained}
                                        onChange={changeEventEnglishObtained}
                                        error={errorEnglishObtained}
                                        helperText={errorTextEnglishObtained}
                                        required
                                        onBlur={blurEventEnglishObtained}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="english"
                                        label="English Out of"
                                        variant="filled"
                                        fullWidth
                                        name="English Out of"
                                        value={englishOutof}
                                        onChange={changeEventEnglishOutof}
                                        error={errorEnglishOutof}
                                        helperText={errorTextEnglishOutof}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField helper-text-disabled"
                                        id="englishper"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={englishperofMarks}
                                        onChange={changeEventEnglishPerofMarks}
                                        error={errorEnglishPerofMarks}
                                        helperText={errorTextEnglishPerofMarks}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Mathematics(Higher)</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="mathematics"
                                        label="Mathematics Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Mathematics Obtained"
                                        value={mathmaticsObtained}
                                        onChange={changeEventMathmaticsObtained}
                                        error={errorMathmaticsObtained}
                                        helperText={errorTextMathmaticsObtained}
                                        required
                                        onBlur={blurEventMathmaticsObtained}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="Mathematicsoutof"
                                        label="Mathematics Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Mathematics Out of"
                                        value={mathmaticsOutof}
                                        onChange={changeEventMathmaticsOutof}
                                        error={errorMathmaticsOutof}
                                        helperText={errorTextMathmaticsOutof}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="mathmaticspermarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={mathmaticsperofMarks}
                                        onChange={changeEventMathmaticsPerofMarks}
                                        error={errorMathmaticsPerofMarks}
                                        helperText={errorTextMathmaticsPerofMarks}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Science</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="science"
                                        label="Science Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Science Obtained"
                                        value={scienceObtained}
                                        onChange={changeEventScienceObtained}
                                        error={errorScienceObtained}
                                        helperText={errorTextScienceObtained}
                                        required
                                        onBlur={blurEventScienceObtained}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="scienceoutof"
                                        label="Science Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Science Out of"
                                        value={scienceOutof}
                                        onChange={changeEventScienceOutof}
                                        error={errorScienceOutof}
                                        helperText={errorTextScienceOutof}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="sciencepermarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={scienceperofMarks}
                                        onChange={changeEventSciencePerofMarks}
                                        error={errorSciencePerofMarks}
                                        helperText={errorTextSciencePerofMarks}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <InputLabel id="demo-simple-select-label" className="mt-1 lightInputFields">Total (All Subject)</InputLabel>
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField" id="science"
                                        label="Total Obtained"
                                        variant="filled"
                                        fullWidth
                                        name="Total Obtained"
                                        value={totalObtained}
                                        onChange={changeEventTotalObtained}
                                        error={errorTotalObtained}
                                        helperText={errorTextTotalObtained}
                                        required
                                        onBlur={blurEventTotalObtained}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 noBgLightInputField"
                                        id="totaloutof"
                                        label="Total Out of"
                                        variant="filled"
                                        fullWidth
                                        name="Total Out of"
                                        value={totalOutof}
                                        onChange={changeEventTotalOutof}
                                        error={errorTotalOutof}
                                        helperText={errorTextTotalOutof}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} className="d-flex Width-100">
                                    <TextField className="lightInputFields mt-1 helper-text-disabled noBgLightInputField"
                                        id="percentagemarks"
                                        label="% of Marks"
                                        variant="filled"
                                        fullWidth
                                        name="% of Marks"
                                        value={totalperofMarks}
                                        onChange={changeEventPerofMarks}
                                        error={errorTotalPerofMarks}
                                        helperText={errorTextTotalPerofMarks}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className="d-flex jc-space-around fd-row">
                                <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100"></Grid>
                                <Grid item xs={12} sm={3} className="d-flex jc-center mt-1 Width-100">
                                    <FormControl variant="filled" className={classes.formControl}>
                                        <InputLabel id="demo-simple-select-label">Trade prefered</InputLabel>
                                        <Select className="lightInputFields"
                                            labelId="demo-simple-select-label"
                                            id="ddlEmployeeType"
                                            value={tradePrefered}
                                            onChange={changeEventTradePrefered}
                                        >
                                            {itemsTradePrefered.map(item => (
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.trade}
                                                </MenuItem>)
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} className="d-flex jc-center mt-1 Width-100"></Grid>
                                <Grid item xs={12} sm={12} className="privacyBtn">
                                    <Button className="ns-btn-primary ml-1 mr-1 mb-1 privacyBtn" onClick={clickEventSaveAsDraft} >
                                        <span>{buttonTextSave}</span>
                                    </Button>
                                    <Button className="ns-btn-primary ml-1 mr-1 mb-1 privacyBtn" onClick={clickEventRegisterCandidate}>
                                        <span>{buttonTextSubmit}</span>
                                    </Button>

                                    <Button className="ns-btn-primary ml-1 mr-1 mb-1" onClick={clickEventClearData}>
                                        <span>Clear</span>
                                    </Button>
                                </Grid>
                            </Grid>
                            {/*-----------------------10th Qualification Details End------------------------------*/}

                        </Grid>

                        <Dialog
                            open={openImgMSG}
                            onClose={handleCloseImgMSG}
                            aria-labelledby="draggable-dialog-title"
                            id="templateUploadSuccess">
                            <DialogTitle className={openClassNameImgMSG} style={{ cursor: 'move', background: '#00B3B3', }} id="draggable-dialog-title">
                                {openTypeImgMSG}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText className="clr-dark-blue">
                                    {openAlertImgMSG}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="bg-content">
                                <Button variant="contained" autoFocus onClick={handleCloseImgMSG} className="ns-btn-secondary-light">
                                    <span className="f-16 fw-bold clr-white">OK</span>
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="draggable-dialog-title"
                            id="templateUploadSuccess">
                            <DialogTitle className={openClassName} style={{ cursor: 'move', background: '#00B3B3', }} id="draggable-dialog-title">
                                {openType}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText className="clr-dark-blue">
                                    {openAlert}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="bg-content">
                                <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                                    <span className="f-16 fw-bold clr-white">OK</span>
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={openConfirm}
                            onClose={handleCloseConfirm}
                            aria-labelledby="draggable-dialog-title"
                            id="templateUploadClear">
                            <DialogTitle className={openClassName} style={{ cursor: 'move', background: '#00B3B3', }} id="draggable-dialog-title">
                                {openType}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText className="clr-dark-blue">
                                    {openAlertConfirm}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="bg-content">
                                <Button variant="contained" autoFocus onClick={handleConfirm} className="ns-btn-secondary-light mr-15px">
                                    <span className="f-16 fw-bold clr-white">OK</span>
                                </Button>
                                <Button variant="contained" autoFocus onClick={handleCloseConfirm} className="ns-btn-secondary-light">
                                    <span className="f-16 fw-bold clr-white">Cancel</span>
                                </Button>

                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={openLoader}
                            //onClose={handleClose}
                            aria-labelledby="draggable-dialog-title"
                            id="templateUploadSuccess"
                            PaperProps={{
                                style: {
                                    backgroundColor: "transparent",
                                    boxShadow: "none",
                                    borderColor: "transparent"
                                },
                            }}
                        >
                            <DialogContent>
                                <CircularProgress />
                            </DialogContent>
                        </Dialog>
                    </Grid>
                </form>
            </div>

        </ThemeProvider>
    );
}
